"use strict";
// Code generated by cmd/id. DO NOT EDIT!
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdBoolean = 1;
exports.IdSByte = 2;
exports.IdByte = 3;
exports.IdInt16 = 4;
exports.IdUInt16 = 5;
exports.IdInt32 = 6;
exports.IdUInt32 = 7;
exports.IdInt64 = 8;
exports.IdUInt64 = 9;
exports.IdFloat = 10;
exports.IdDouble = 11;
exports.IdString = 12;
exports.IdDateTime = 13;
exports.IdGuid = 14;
exports.IdByteString = 15;
exports.IdXmlElement = 16;
exports.IdNodeId = 17;
exports.IdExpandedNodeId = 18;
exports.IdStatusCode = 19;
exports.IdQualifiedName = 20;
exports.IdLocalizedText = 21;
exports.IdStructure = 22;
exports.IdDataValue = 23;
exports.IdBaseDataType = 24;
exports.IdDiagnosticInfo = 25;
exports.IdNumber = 26;
exports.IdInteger = 27;
exports.IdUInteger = 28;
exports.IdEnumeration = 29;
exports.IdImage = 30;
exports.IdReferences = 31;
exports.IdNonHierarchicalReferences = 32;
exports.IdHierarchicalReferences = 33;
exports.IdHasChild = 34;
exports.IdOrganizes = 35;
exports.IdHasEventSource = 36;
exports.IdHasModellingRule = 37;
exports.IdHasEncoding = 38;
exports.IdHasDescription = 39;
exports.IdHasTypeDefinition = 40;
exports.IdGeneratesEvent = 41;
exports.IdAggregates = 44;
exports.IdHasSubtype = 45;
exports.IdHasProperty = 46;
exports.IdHasComponent = 47;
exports.IdHasNotifier = 48;
exports.IdHasOrderedComponent = 49;
exports.IdDecimal = 50;
exports.IdFromState = 51;
exports.IdToState = 52;
exports.IdHasCause = 53;
exports.IdHasEffect = 54;
exports.IdHasHistoricalConfiguration = 56;
exports.IdBaseObjectType = 58;
exports.IdFolderType = 61;
exports.IdBaseVariableType = 62;
exports.IdBaseDataVariableType = 63;
exports.IdPropertyType = 68;
exports.IdDataTypeDescriptionType = 69;
exports.IdDataTypeDictionaryType = 72;
exports.IdDataTypeSystemType = 75;
exports.IdDataTypeEncodingType = 76;
exports.IdModellingRuleType = 77;
exports.IdModellingRuleMandatory = 78;
exports.IdModellingRuleOptional = 80;
exports.IdModellingRuleExposesItsArray = 83;
exports.IdRootFolder = 84;
exports.IdObjectsFolder = 85;
exports.IdTypesFolder = 86;
exports.IdViewsFolder = 87;
exports.IdObjectTypesFolder = 88;
exports.IdVariableTypesFolder = 89;
exports.IdDataTypesFolder = 90;
exports.IdReferenceTypesFolder = 91;
exports.IdXmlSchemaTypeSystem = 92;
exports.IdOPCBinarySchemaTypeSystem = 93;
exports.IdPermissionType = 94;
exports.IdAccessRestrictionType = 95;
exports.IdRolePermissionType = 96;
exports.IdDataTypeDefinition = 97;
exports.IdStructureType = 98;
exports.IdStructureDefinition = 99;
exports.IdEnumDefinition = 100;
exports.IdStructureField = 101;
exports.IdEnumField = 102;
exports.IdDataTypeDescriptionTypeDataTypeVersion = 104;
exports.IdDataTypeDescriptionTypeDictionaryFragment = 105;
exports.IdDataTypeDictionaryTypeDataTypeVersion = 106;
exports.IdDataTypeDictionaryTypeNamespaceUri = 107;
exports.IdModellingRuleTypeNamingRule = 111;
exports.IdModellingRuleMandatoryNamingRule = 112;
exports.IdModellingRuleOptionalNamingRule = 113;
exports.IdModellingRuleExposesItsArrayNamingRule = 114;
exports.IdHasSubStateMachine = 117;
exports.IdNamingRuleType = 120;
exports.IdDataTypeDefinitionEncodingDefaultBinary = 121;
exports.IdStructureDefinitionEncodingDefaultBinary = 122;
exports.IdEnumDefinitionEncodingDefaultBinary = 123;
exports.IdDataSetMetaDataTypeEncodingDefaultBinary = 124;
exports.IdDataTypeDescriptionEncodingDefaultBinary = 125;
exports.IdStructureDescriptionEncodingDefaultBinary = 126;
exports.IdEnumDescriptionEncodingDefaultBinary = 127;
exports.IdRolePermissionTypeEncodingDefaultBinary = 128;
exports.IdHasArgumentDescription = 129;
exports.IdHasOptionalInputArgumentDescription = 131;
exports.IdIdType = 256;
exports.IdNodeClass = 257;
exports.IdNode = 258;
exports.IdNodeEncodingDefaultXml = 259;
exports.IdNodeEncodingDefaultBinary = 260;
exports.IdObjectNode = 261;
exports.IdObjectNodeEncodingDefaultXml = 262;
exports.IdObjectNodeEncodingDefaultBinary = 263;
exports.IdObjectTypeNode = 264;
exports.IdObjectTypeNodeEncodingDefaultXml = 265;
exports.IdObjectTypeNodeEncodingDefaultBinary = 266;
exports.IdVariableNode = 267;
exports.IdVariableNodeEncodingDefaultXml = 268;
exports.IdVariableNodeEncodingDefaultBinary = 269;
exports.IdVariableTypeNode = 270;
exports.IdVariableTypeNodeEncodingDefaultXml = 271;
exports.IdVariableTypeNodeEncodingDefaultBinary = 272;
exports.IdReferenceTypeNode = 273;
exports.IdReferenceTypeNodeEncodingDefaultXml = 274;
exports.IdReferenceTypeNodeEncodingDefaultBinary = 275;
exports.IdMethodNode = 276;
exports.IdMethodNodeEncodingDefaultXml = 277;
exports.IdMethodNodeEncodingDefaultBinary = 278;
exports.IdViewNode = 279;
exports.IdViewNodeEncodingDefaultXml = 280;
exports.IdViewNodeEncodingDefaultBinary = 281;
exports.IdDataTypeNode = 282;
exports.IdDataTypeNodeEncodingDefaultXml = 283;
exports.IdDataTypeNodeEncodingDefaultBinary = 284;
exports.IdReferenceNode = 285;
exports.IdReferenceNodeEncodingDefaultXml = 286;
exports.IdReferenceNodeEncodingDefaultBinary = 287;
exports.IdIntegerId = 288;
exports.IdCounter = 289;
exports.IdDuration = 290;
exports.IdNumericRange = 291;
exports.IdTime = 292;
exports.IdDate = 293;
exports.IdUtcTime = 294;
exports.IdLocaleId = 295;
exports.IdArgument = 296;
exports.IdArgumentEncodingDefaultXml = 297;
exports.IdArgumentEncodingDefaultBinary = 298;
exports.IdStatusResult = 299;
exports.IdStatusResultEncodingDefaultXml = 300;
exports.IdStatusResultEncodingDefaultBinary = 301;
exports.IdMessageSecurityMode = 302;
exports.IdUserTokenType = 303;
exports.IdUserTokenPolicy = 304;
exports.IdUserTokenPolicyEncodingDefaultXml = 305;
exports.IdUserTokenPolicyEncodingDefaultBinary = 306;
exports.IdApplicationType = 307;
exports.IdApplicationDescription = 308;
exports.IdApplicationDescriptionEncodingDefaultXml = 309;
exports.IdApplicationDescriptionEncodingDefaultBinary = 310;
exports.IdApplicationInstanceCertificate = 311;
exports.IdEndpointDescription = 312;
exports.IdEndpointDescriptionEncodingDefaultXml = 313;
exports.IdEndpointDescriptionEncodingDefaultBinary = 314;
exports.IdSecurityTokenRequestType = 315;
exports.IdUserIdentityToken = 316;
exports.IdUserIdentityTokenEncodingDefaultXml = 317;
exports.IdUserIdentityTokenEncodingDefaultBinary = 318;
exports.IdAnonymousIdentityToken = 319;
exports.IdAnonymousIdentityTokenEncodingDefaultXml = 320;
exports.IdAnonymousIdentityTokenEncodingDefaultBinary = 321;
exports.IdUserNameIdentityToken = 322;
exports.IdUserNameIdentityTokenEncodingDefaultXml = 323;
exports.IdUserNameIdentityTokenEncodingDefaultBinary = 324;
exports.IdX509IdentityToken = 325;
exports.IdX509IdentityTokenEncodingDefaultXml = 326;
exports.IdX509IdentityTokenEncodingDefaultBinary = 327;
exports.IdEndpointConfiguration = 331;
exports.IdEndpointConfigurationEncodingDefaultXml = 332;
exports.IdEndpointConfigurationEncodingDefaultBinary = 333;
exports.IdBuildInfo = 338;
exports.IdBuildInfoEncodingDefaultXml = 339;
exports.IdBuildInfoEncodingDefaultBinary = 340;
exports.IdSignedSoftwareCertificate = 344;
exports.IdSignedSoftwareCertificateEncodingDefaultXml = 345;
exports.IdSignedSoftwareCertificateEncodingDefaultBinary = 346;
exports.IdAttributeWriteMask = 347;
exports.IdNodeAttributesMask = 348;
exports.IdNodeAttributes = 349;
exports.IdNodeAttributesEncodingDefaultXml = 350;
exports.IdNodeAttributesEncodingDefaultBinary = 351;
exports.IdObjectAttributes = 352;
exports.IdObjectAttributesEncodingDefaultXml = 353;
exports.IdObjectAttributesEncodingDefaultBinary = 354;
exports.IdVariableAttributes = 355;
exports.IdVariableAttributesEncodingDefaultXml = 356;
exports.IdVariableAttributesEncodingDefaultBinary = 357;
exports.IdMethodAttributes = 358;
exports.IdMethodAttributesEncodingDefaultXml = 359;
exports.IdMethodAttributesEncodingDefaultBinary = 360;
exports.IdObjectTypeAttributes = 361;
exports.IdObjectTypeAttributesEncodingDefaultXml = 362;
exports.IdObjectTypeAttributesEncodingDefaultBinary = 363;
exports.IdVariableTypeAttributes = 364;
exports.IdVariableTypeAttributesEncodingDefaultXml = 365;
exports.IdVariableTypeAttributesEncodingDefaultBinary = 366;
exports.IdReferenceTypeAttributes = 367;
exports.IdReferenceTypeAttributesEncodingDefaultXml = 368;
exports.IdReferenceTypeAttributesEncodingDefaultBinary = 369;
exports.IdDataTypeAttributes = 370;
exports.IdDataTypeAttributesEncodingDefaultXml = 371;
exports.IdDataTypeAttributesEncodingDefaultBinary = 372;
exports.IdViewAttributes = 373;
exports.IdViewAttributesEncodingDefaultXml = 374;
exports.IdViewAttributesEncodingDefaultBinary = 375;
exports.IdAddNodesItem = 376;
exports.IdAddNodesItemEncodingDefaultXml = 377;
exports.IdAddNodesItemEncodingDefaultBinary = 378;
exports.IdAddReferencesItem = 379;
exports.IdAddReferencesItemEncodingDefaultXml = 380;
exports.IdAddReferencesItemEncodingDefaultBinary = 381;
exports.IdDeleteNodesItem = 382;
exports.IdDeleteNodesItemEncodingDefaultXml = 383;
exports.IdDeleteNodesItemEncodingDefaultBinary = 384;
exports.IdDeleteReferencesItem = 385;
exports.IdDeleteReferencesItemEncodingDefaultXml = 386;
exports.IdDeleteReferencesItemEncodingDefaultBinary = 387;
exports.IdSessionAuthenticationToken = 388;
exports.IdRequestHeader = 389;
exports.IdRequestHeaderEncodingDefaultXml = 390;
exports.IdRequestHeaderEncodingDefaultBinary = 391;
exports.IdResponseHeader = 392;
exports.IdResponseHeaderEncodingDefaultXml = 393;
exports.IdResponseHeaderEncodingDefaultBinary = 394;
exports.IdServiceFault = 395;
exports.IdServiceFaultEncodingDefaultXml = 396;
exports.IdServiceFaultEncodingDefaultBinary = 397;
exports.IdFindServersRequest = 420;
exports.IdFindServersRequestEncodingDefaultXml = 421;
exports.IdFindServersRequestEncodingDefaultBinary = 422;
exports.IdFindServersResponse = 423;
exports.IdFindServersResponseEncodingDefaultXml = 424;
exports.IdFindServersResponseEncodingDefaultBinary = 425;
exports.IdGetEndpointsRequest = 426;
exports.IdGetEndpointsRequestEncodingDefaultXml = 427;
exports.IdGetEndpointsRequestEncodingDefaultBinary = 428;
exports.IdGetEndpointsResponse = 429;
exports.IdGetEndpointsResponseEncodingDefaultXml = 430;
exports.IdGetEndpointsResponseEncodingDefaultBinary = 431;
exports.IdRegisteredServer = 432;
exports.IdRegisteredServerEncodingDefaultXml = 433;
exports.IdRegisteredServerEncodingDefaultBinary = 434;
exports.IdRegisterServerRequest = 435;
exports.IdRegisterServerRequestEncodingDefaultXml = 436;
exports.IdRegisterServerRequestEncodingDefaultBinary = 437;
exports.IdRegisterServerResponse = 438;
exports.IdRegisterServerResponseEncodingDefaultXml = 439;
exports.IdRegisterServerResponseEncodingDefaultBinary = 440;
exports.IdChannelSecurityToken = 441;
exports.IdChannelSecurityTokenEncodingDefaultXml = 442;
exports.IdChannelSecurityTokenEncodingDefaultBinary = 443;
exports.IdOpenSecureChannelRequest = 444;
exports.IdOpenSecureChannelRequestEncodingDefaultXml = 445;
exports.IdOpenSecureChannelRequestEncodingDefaultBinary = 446;
exports.IdOpenSecureChannelResponse = 447;
exports.IdOpenSecureChannelResponseEncodingDefaultXml = 448;
exports.IdOpenSecureChannelResponseEncodingDefaultBinary = 449;
exports.IdCloseSecureChannelRequest = 450;
exports.IdCloseSecureChannelRequestEncodingDefaultXml = 451;
exports.IdCloseSecureChannelRequestEncodingDefaultBinary = 452;
exports.IdCloseSecureChannelResponse = 453;
exports.IdCloseSecureChannelResponseEncodingDefaultXml = 454;
exports.IdCloseSecureChannelResponseEncodingDefaultBinary = 455;
exports.IdSignatureData = 456;
exports.IdSignatureDataEncodingDefaultXml = 457;
exports.IdSignatureDataEncodingDefaultBinary = 458;
exports.IdCreateSessionRequest = 459;
exports.IdCreateSessionRequestEncodingDefaultXml = 460;
exports.IdCreateSessionRequestEncodingDefaultBinary = 461;
exports.IdCreateSessionResponse = 462;
exports.IdCreateSessionResponseEncodingDefaultXml = 463;
exports.IdCreateSessionResponseEncodingDefaultBinary = 464;
exports.IdActivateSessionRequest = 465;
exports.IdActivateSessionRequestEncodingDefaultXml = 466;
exports.IdActivateSessionRequestEncodingDefaultBinary = 467;
exports.IdActivateSessionResponse = 468;
exports.IdActivateSessionResponseEncodingDefaultXml = 469;
exports.IdActivateSessionResponseEncodingDefaultBinary = 470;
exports.IdCloseSessionRequest = 471;
exports.IdCloseSessionRequestEncodingDefaultXml = 472;
exports.IdCloseSessionRequestEncodingDefaultBinary = 473;
exports.IdCloseSessionResponse = 474;
exports.IdCloseSessionResponseEncodingDefaultXml = 475;
exports.IdCloseSessionResponseEncodingDefaultBinary = 476;
exports.IdCancelRequest = 477;
exports.IdCancelRequestEncodingDefaultXml = 478;
exports.IdCancelRequestEncodingDefaultBinary = 479;
exports.IdCancelResponse = 480;
exports.IdCancelResponseEncodingDefaultXml = 481;
exports.IdCancelResponseEncodingDefaultBinary = 482;
exports.IdAddNodesResult = 483;
exports.IdAddNodesResultEncodingDefaultXml = 484;
exports.IdAddNodesResultEncodingDefaultBinary = 485;
exports.IdAddNodesRequest = 486;
exports.IdAddNodesRequestEncodingDefaultXml = 487;
exports.IdAddNodesRequestEncodingDefaultBinary = 488;
exports.IdAddNodesResponse = 489;
exports.IdAddNodesResponseEncodingDefaultXml = 490;
exports.IdAddNodesResponseEncodingDefaultBinary = 491;
exports.IdAddReferencesRequest = 492;
exports.IdAddReferencesRequestEncodingDefaultXml = 493;
exports.IdAddReferencesRequestEncodingDefaultBinary = 494;
exports.IdAddReferencesResponse = 495;
exports.IdAddReferencesResponseEncodingDefaultXml = 496;
exports.IdAddReferencesResponseEncodingDefaultBinary = 497;
exports.IdDeleteNodesRequest = 498;
exports.IdDeleteNodesRequestEncodingDefaultXml = 499;
exports.IdDeleteNodesRequestEncodingDefaultBinary = 500;
exports.IdDeleteNodesResponse = 501;
exports.IdDeleteNodesResponseEncodingDefaultXml = 502;
exports.IdDeleteNodesResponseEncodingDefaultBinary = 503;
exports.IdDeleteReferencesRequest = 504;
exports.IdDeleteReferencesRequestEncodingDefaultXml = 505;
exports.IdDeleteReferencesRequestEncodingDefaultBinary = 506;
exports.IdDeleteReferencesResponse = 507;
exports.IdDeleteReferencesResponseEncodingDefaultXml = 508;
exports.IdDeleteReferencesResponseEncodingDefaultBinary = 509;
exports.IdBrowseDirection = 510;
exports.IdViewDescription = 511;
exports.IdViewDescriptionEncodingDefaultXml = 512;
exports.IdViewDescriptionEncodingDefaultBinary = 513;
exports.IdBrowseDescription = 514;
exports.IdBrowseDescriptionEncodingDefaultXml = 515;
exports.IdBrowseDescriptionEncodingDefaultBinary = 516;
exports.IdBrowseResultMask = 517;
exports.IdReferenceDescription = 518;
exports.IdReferenceDescriptionEncodingDefaultXml = 519;
exports.IdReferenceDescriptionEncodingDefaultBinary = 520;
exports.IdContinuationPoint = 521;
exports.IdBrowseResult = 522;
exports.IdBrowseResultEncodingDefaultXml = 523;
exports.IdBrowseResultEncodingDefaultBinary = 524;
exports.IdBrowseRequest = 525;
exports.IdBrowseRequestEncodingDefaultXml = 526;
exports.IdBrowseRequestEncodingDefaultBinary = 527;
exports.IdBrowseResponse = 528;
exports.IdBrowseResponseEncodingDefaultXml = 529;
exports.IdBrowseResponseEncodingDefaultBinary = 530;
exports.IdBrowseNextRequest = 531;
exports.IdBrowseNextRequestEncodingDefaultXml = 532;
exports.IdBrowseNextRequestEncodingDefaultBinary = 533;
exports.IdBrowseNextResponse = 534;
exports.IdBrowseNextResponseEncodingDefaultXml = 535;
exports.IdBrowseNextResponseEncodingDefaultBinary = 536;
exports.IdRelativePathElement = 537;
exports.IdRelativePathElementEncodingDefaultXml = 538;
exports.IdRelativePathElementEncodingDefaultBinary = 539;
exports.IdRelativePath = 540;
exports.IdRelativePathEncodingDefaultXml = 541;
exports.IdRelativePathEncodingDefaultBinary = 542;
exports.IdBrowsePath = 543;
exports.IdBrowsePathEncodingDefaultXml = 544;
exports.IdBrowsePathEncodingDefaultBinary = 545;
exports.IdBrowsePathTarget = 546;
exports.IdBrowsePathTargetEncodingDefaultXml = 547;
exports.IdBrowsePathTargetEncodingDefaultBinary = 548;
exports.IdBrowsePathResult = 549;
exports.IdBrowsePathResultEncodingDefaultXml = 550;
exports.IdBrowsePathResultEncodingDefaultBinary = 551;
exports.IdTranslateBrowsePathsToNodeIdsRequest = 552;
exports.IdTranslateBrowsePathsToNodeIdsRequestEncodingDefaultXml = 553;
exports.IdTranslateBrowsePathsToNodeIdsRequestEncodingDefaultBinary = 554;
exports.IdTranslateBrowsePathsToNodeIdsResponse = 555;
exports.IdTranslateBrowsePathsToNodeIdsResponseEncodingDefaultXml = 556;
exports.IdTranslateBrowsePathsToNodeIdsResponseEncodingDefaultBinary = 557;
exports.IdRegisterNodesRequest = 558;
exports.IdRegisterNodesRequestEncodingDefaultXml = 559;
exports.IdRegisterNodesRequestEncodingDefaultBinary = 560;
exports.IdRegisterNodesResponse = 561;
exports.IdRegisterNodesResponseEncodingDefaultXml = 562;
exports.IdRegisterNodesResponseEncodingDefaultBinary = 563;
exports.IdUnregisterNodesRequest = 564;
exports.IdUnregisterNodesRequestEncodingDefaultXml = 565;
exports.IdUnregisterNodesRequestEncodingDefaultBinary = 566;
exports.IdUnregisterNodesResponse = 567;
exports.IdUnregisterNodesResponseEncodingDefaultXml = 568;
exports.IdUnregisterNodesResponseEncodingDefaultBinary = 569;
exports.IdQueryDataDescription = 570;
exports.IdQueryDataDescriptionEncodingDefaultXml = 571;
exports.IdQueryDataDescriptionEncodingDefaultBinary = 572;
exports.IdNodeTypeDescription = 573;
exports.IdNodeTypeDescriptionEncodingDefaultXml = 574;
exports.IdNodeTypeDescriptionEncodingDefaultBinary = 575;
exports.IdFilterOperator = 576;
exports.IdQueryDataSet = 577;
exports.IdQueryDataSetEncodingDefaultXml = 578;
exports.IdQueryDataSetEncodingDefaultBinary = 579;
exports.IdNodeReference = 580;
exports.IdNodeReferenceEncodingDefaultXml = 581;
exports.IdNodeReferenceEncodingDefaultBinary = 582;
exports.IdContentFilterElement = 583;
exports.IdContentFilterElementEncodingDefaultXml = 584;
exports.IdContentFilterElementEncodingDefaultBinary = 585;
exports.IdContentFilter = 586;
exports.IdContentFilterEncodingDefaultXml = 587;
exports.IdContentFilterEncodingDefaultBinary = 588;
exports.IdFilterOperand = 589;
exports.IdFilterOperandEncodingDefaultXml = 590;
exports.IdFilterOperandEncodingDefaultBinary = 591;
exports.IdElementOperand = 592;
exports.IdElementOperandEncodingDefaultXml = 593;
exports.IdElementOperandEncodingDefaultBinary = 594;
exports.IdLiteralOperand = 595;
exports.IdLiteralOperandEncodingDefaultXml = 596;
exports.IdLiteralOperandEncodingDefaultBinary = 597;
exports.IdAttributeOperand = 598;
exports.IdAttributeOperandEncodingDefaultXml = 599;
exports.IdAttributeOperandEncodingDefaultBinary = 600;
exports.IdSimpleAttributeOperand = 601;
exports.IdSimpleAttributeOperandEncodingDefaultXml = 602;
exports.IdSimpleAttributeOperandEncodingDefaultBinary = 603;
exports.IdContentFilterElementResult = 604;
exports.IdContentFilterElementResultEncodingDefaultXml = 605;
exports.IdContentFilterElementResultEncodingDefaultBinary = 606;
exports.IdContentFilterResult = 607;
exports.IdContentFilterResultEncodingDefaultXml = 608;
exports.IdContentFilterResultEncodingDefaultBinary = 609;
exports.IdParsingResult = 610;
exports.IdParsingResultEncodingDefaultXml = 611;
exports.IdParsingResultEncodingDefaultBinary = 612;
exports.IdQueryFirstRequest = 613;
exports.IdQueryFirstRequestEncodingDefaultXml = 614;
exports.IdQueryFirstRequestEncodingDefaultBinary = 615;
exports.IdQueryFirstResponse = 616;
exports.IdQueryFirstResponseEncodingDefaultXml = 617;
exports.IdQueryFirstResponseEncodingDefaultBinary = 618;
exports.IdQueryNextRequest = 619;
exports.IdQueryNextRequestEncodingDefaultXml = 620;
exports.IdQueryNextRequestEncodingDefaultBinary = 621;
exports.IdQueryNextResponse = 622;
exports.IdQueryNextResponseEncodingDefaultXml = 623;
exports.IdQueryNextResponseEncodingDefaultBinary = 624;
exports.IdTimestampsToReturn = 625;
exports.IdReadValueId = 626;
exports.IdReadValueIdEncodingDefaultXml = 627;
exports.IdReadValueIdEncodingDefaultBinary = 628;
exports.IdReadRequest = 629;
exports.IdReadRequestEncodingDefaultXml = 630;
exports.IdReadRequestEncodingDefaultBinary = 631;
exports.IdReadResponse = 632;
exports.IdReadResponseEncodingDefaultXml = 633;
exports.IdReadResponseEncodingDefaultBinary = 634;
exports.IdHistoryReadValueId = 635;
exports.IdHistoryReadValueIdEncodingDefaultXml = 636;
exports.IdHistoryReadValueIdEncodingDefaultBinary = 637;
exports.IdHistoryReadResult = 638;
exports.IdHistoryReadResultEncodingDefaultXml = 639;
exports.IdHistoryReadResultEncodingDefaultBinary = 640;
exports.IdHistoryReadDetails = 641;
exports.IdHistoryReadDetailsEncodingDefaultXml = 642;
exports.IdHistoryReadDetailsEncodingDefaultBinary = 643;
exports.IdReadEventDetails = 644;
exports.IdReadEventDetailsEncodingDefaultXml = 645;
exports.IdReadEventDetailsEncodingDefaultBinary = 646;
exports.IdReadRawModifiedDetails = 647;
exports.IdReadRawModifiedDetailsEncodingDefaultXml = 648;
exports.IdReadRawModifiedDetailsEncodingDefaultBinary = 649;
exports.IdReadProcessedDetails = 650;
exports.IdReadProcessedDetailsEncodingDefaultXml = 651;
exports.IdReadProcessedDetailsEncodingDefaultBinary = 652;
exports.IdReadAtTimeDetails = 653;
exports.IdReadAtTimeDetailsEncodingDefaultXml = 654;
exports.IdReadAtTimeDetailsEncodingDefaultBinary = 655;
exports.IdHistoryData = 656;
exports.IdHistoryDataEncodingDefaultXml = 657;
exports.IdHistoryDataEncodingDefaultBinary = 658;
exports.IdHistoryEvent = 659;
exports.IdHistoryEventEncodingDefaultXml = 660;
exports.IdHistoryEventEncodingDefaultBinary = 661;
exports.IdHistoryReadRequest = 662;
exports.IdHistoryReadRequestEncodingDefaultXml = 663;
exports.IdHistoryReadRequestEncodingDefaultBinary = 664;
exports.IdHistoryReadResponse = 665;
exports.IdHistoryReadResponseEncodingDefaultXml = 666;
exports.IdHistoryReadResponseEncodingDefaultBinary = 667;
exports.IdWriteValue = 668;
exports.IdWriteValueEncodingDefaultXml = 669;
exports.IdWriteValueEncodingDefaultBinary = 670;
exports.IdWriteRequest = 671;
exports.IdWriteRequestEncodingDefaultXml = 672;
exports.IdWriteRequestEncodingDefaultBinary = 673;
exports.IdWriteResponse = 674;
exports.IdWriteResponseEncodingDefaultXml = 675;
exports.IdWriteResponseEncodingDefaultBinary = 676;
exports.IdHistoryUpdateDetails = 677;
exports.IdHistoryUpdateDetailsEncodingDefaultXml = 678;
exports.IdHistoryUpdateDetailsEncodingDefaultBinary = 679;
exports.IdUpdateDataDetails = 680;
exports.IdUpdateDataDetailsEncodingDefaultXml = 681;
exports.IdUpdateDataDetailsEncodingDefaultBinary = 682;
exports.IdUpdateEventDetails = 683;
exports.IdUpdateEventDetailsEncodingDefaultXml = 684;
exports.IdUpdateEventDetailsEncodingDefaultBinary = 685;
exports.IdDeleteRawModifiedDetails = 686;
exports.IdDeleteRawModifiedDetailsEncodingDefaultXml = 687;
exports.IdDeleteRawModifiedDetailsEncodingDefaultBinary = 688;
exports.IdDeleteAtTimeDetails = 689;
exports.IdDeleteAtTimeDetailsEncodingDefaultXml = 690;
exports.IdDeleteAtTimeDetailsEncodingDefaultBinary = 691;
exports.IdDeleteEventDetails = 692;
exports.IdDeleteEventDetailsEncodingDefaultXml = 693;
exports.IdDeleteEventDetailsEncodingDefaultBinary = 694;
exports.IdHistoryUpdateResult = 695;
exports.IdHistoryUpdateResultEncodingDefaultXml = 696;
exports.IdHistoryUpdateResultEncodingDefaultBinary = 697;
exports.IdHistoryUpdateRequest = 698;
exports.IdHistoryUpdateRequestEncodingDefaultXml = 699;
exports.IdHistoryUpdateRequestEncodingDefaultBinary = 700;
exports.IdHistoryUpdateResponse = 701;
exports.IdHistoryUpdateResponseEncodingDefaultXml = 702;
exports.IdHistoryUpdateResponseEncodingDefaultBinary = 703;
exports.IdCallMethodRequest = 704;
exports.IdCallMethodRequestEncodingDefaultXml = 705;
exports.IdCallMethodRequestEncodingDefaultBinary = 706;
exports.IdCallMethodResult = 707;
exports.IdCallMethodResultEncodingDefaultXml = 708;
exports.IdCallMethodResultEncodingDefaultBinary = 709;
exports.IdCallRequest = 710;
exports.IdCallRequestEncodingDefaultXml = 711;
exports.IdCallRequestEncodingDefaultBinary = 712;
exports.IdCallResponse = 713;
exports.IdCallResponseEncodingDefaultXml = 714;
exports.IdCallResponseEncodingDefaultBinary = 715;
exports.IdMonitoringMode = 716;
exports.IdDataChangeTrigger = 717;
exports.IdDeadbandType = 718;
exports.IdMonitoringFilter = 719;
exports.IdMonitoringFilterEncodingDefaultXml = 720;
exports.IdMonitoringFilterEncodingDefaultBinary = 721;
exports.IdDataChangeFilter = 722;
exports.IdDataChangeFilterEncodingDefaultXml = 723;
exports.IdDataChangeFilterEncodingDefaultBinary = 724;
exports.IdEventFilter = 725;
exports.IdEventFilterEncodingDefaultXml = 726;
exports.IdEventFilterEncodingDefaultBinary = 727;
exports.IdAggregateFilter = 728;
exports.IdAggregateFilterEncodingDefaultXml = 729;
exports.IdAggregateFilterEncodingDefaultBinary = 730;
exports.IdMonitoringFilterResult = 731;
exports.IdMonitoringFilterResultEncodingDefaultXml = 732;
exports.IdMonitoringFilterResultEncodingDefaultBinary = 733;
exports.IdEventFilterResult = 734;
exports.IdEventFilterResultEncodingDefaultXml = 735;
exports.IdEventFilterResultEncodingDefaultBinary = 736;
exports.IdAggregateFilterResult = 737;
exports.IdAggregateFilterResultEncodingDefaultXml = 738;
exports.IdAggregateFilterResultEncodingDefaultBinary = 739;
exports.IdMonitoringParameters = 740;
exports.IdMonitoringParametersEncodingDefaultXml = 741;
exports.IdMonitoringParametersEncodingDefaultBinary = 742;
exports.IdMonitoredItemCreateRequest = 743;
exports.IdMonitoredItemCreateRequestEncodingDefaultXml = 744;
exports.IdMonitoredItemCreateRequestEncodingDefaultBinary = 745;
exports.IdMonitoredItemCreateResult = 746;
exports.IdMonitoredItemCreateResultEncodingDefaultXml = 747;
exports.IdMonitoredItemCreateResultEncodingDefaultBinary = 748;
exports.IdCreateMonitoredItemsRequest = 749;
exports.IdCreateMonitoredItemsRequestEncodingDefaultXml = 750;
exports.IdCreateMonitoredItemsRequestEncodingDefaultBinary = 751;
exports.IdCreateMonitoredItemsResponse = 752;
exports.IdCreateMonitoredItemsResponseEncodingDefaultXml = 753;
exports.IdCreateMonitoredItemsResponseEncodingDefaultBinary = 754;
exports.IdMonitoredItemModifyRequest = 755;
exports.IdMonitoredItemModifyRequestEncodingDefaultXml = 756;
exports.IdMonitoredItemModifyRequestEncodingDefaultBinary = 757;
exports.IdMonitoredItemModifyResult = 758;
exports.IdMonitoredItemModifyResultEncodingDefaultXml = 759;
exports.IdMonitoredItemModifyResultEncodingDefaultBinary = 760;
exports.IdModifyMonitoredItemsRequest = 761;
exports.IdModifyMonitoredItemsRequestEncodingDefaultXml = 762;
exports.IdModifyMonitoredItemsRequestEncodingDefaultBinary = 763;
exports.IdModifyMonitoredItemsResponse = 764;
exports.IdModifyMonitoredItemsResponseEncodingDefaultXml = 765;
exports.IdModifyMonitoredItemsResponseEncodingDefaultBinary = 766;
exports.IdSetMonitoringModeRequest = 767;
exports.IdSetMonitoringModeRequestEncodingDefaultXml = 768;
exports.IdSetMonitoringModeRequestEncodingDefaultBinary = 769;
exports.IdSetMonitoringModeResponse = 770;
exports.IdSetMonitoringModeResponseEncodingDefaultXml = 771;
exports.IdSetMonitoringModeResponseEncodingDefaultBinary = 772;
exports.IdSetTriggeringRequest = 773;
exports.IdSetTriggeringRequestEncodingDefaultXml = 774;
exports.IdSetTriggeringRequestEncodingDefaultBinary = 775;
exports.IdSetTriggeringResponse = 776;
exports.IdSetTriggeringResponseEncodingDefaultXml = 777;
exports.IdSetTriggeringResponseEncodingDefaultBinary = 778;
exports.IdDeleteMonitoredItemsRequest = 779;
exports.IdDeleteMonitoredItemsRequestEncodingDefaultXml = 780;
exports.IdDeleteMonitoredItemsRequestEncodingDefaultBinary = 781;
exports.IdDeleteMonitoredItemsResponse = 782;
exports.IdDeleteMonitoredItemsResponseEncodingDefaultXml = 783;
exports.IdDeleteMonitoredItemsResponseEncodingDefaultBinary = 784;
exports.IdCreateSubscriptionRequest = 785;
exports.IdCreateSubscriptionRequestEncodingDefaultXml = 786;
exports.IdCreateSubscriptionRequestEncodingDefaultBinary = 787;
exports.IdCreateSubscriptionResponse = 788;
exports.IdCreateSubscriptionResponseEncodingDefaultXml = 789;
exports.IdCreateSubscriptionResponseEncodingDefaultBinary = 790;
exports.IdModifySubscriptionRequest = 791;
exports.IdModifySubscriptionRequestEncodingDefaultXml = 792;
exports.IdModifySubscriptionRequestEncodingDefaultBinary = 793;
exports.IdModifySubscriptionResponse = 794;
exports.IdModifySubscriptionResponseEncodingDefaultXml = 795;
exports.IdModifySubscriptionResponseEncodingDefaultBinary = 796;
exports.IdSetPublishingModeRequest = 797;
exports.IdSetPublishingModeRequestEncodingDefaultXml = 798;
exports.IdSetPublishingModeRequestEncodingDefaultBinary = 799;
exports.IdSetPublishingModeResponse = 800;
exports.IdSetPublishingModeResponseEncodingDefaultXml = 801;
exports.IdSetPublishingModeResponseEncodingDefaultBinary = 802;
exports.IdNotificationMessage = 803;
exports.IdNotificationMessageEncodingDefaultXml = 804;
exports.IdNotificationMessageEncodingDefaultBinary = 805;
exports.IdMonitoredItemNotification = 806;
exports.IdMonitoredItemNotificationEncodingDefaultXml = 807;
exports.IdMonitoredItemNotificationEncodingDefaultBinary = 808;
exports.IdDataChangeNotification = 809;
exports.IdDataChangeNotificationEncodingDefaultXml = 810;
exports.IdDataChangeNotificationEncodingDefaultBinary = 811;
exports.IdStatusChangeNotification = 818;
exports.IdStatusChangeNotificationEncodingDefaultXml = 819;
exports.IdStatusChangeNotificationEncodingDefaultBinary = 820;
exports.IdSubscriptionAcknowledgement = 821;
exports.IdSubscriptionAcknowledgementEncodingDefaultXml = 822;
exports.IdSubscriptionAcknowledgementEncodingDefaultBinary = 823;
exports.IdPublishRequest = 824;
exports.IdPublishRequestEncodingDefaultXml = 825;
exports.IdPublishRequestEncodingDefaultBinary = 826;
exports.IdPublishResponse = 827;
exports.IdPublishResponseEncodingDefaultXml = 828;
exports.IdPublishResponseEncodingDefaultBinary = 829;
exports.IdRepublishRequest = 830;
exports.IdRepublishRequestEncodingDefaultXml = 831;
exports.IdRepublishRequestEncodingDefaultBinary = 832;
exports.IdRepublishResponse = 833;
exports.IdRepublishResponseEncodingDefaultXml = 834;
exports.IdRepublishResponseEncodingDefaultBinary = 835;
exports.IdTransferResult = 836;
exports.IdTransferResultEncodingDefaultXml = 837;
exports.IdTransferResultEncodingDefaultBinary = 838;
exports.IdTransferSubscriptionsRequest = 839;
exports.IdTransferSubscriptionsRequestEncodingDefaultXml = 840;
exports.IdTransferSubscriptionsRequestEncodingDefaultBinary = 841;
exports.IdTransferSubscriptionsResponse = 842;
exports.IdTransferSubscriptionsResponseEncodingDefaultXml = 843;
exports.IdTransferSubscriptionsResponseEncodingDefaultBinary = 844;
exports.IdDeleteSubscriptionsRequest = 845;
exports.IdDeleteSubscriptionsRequestEncodingDefaultXml = 846;
exports.IdDeleteSubscriptionsRequestEncodingDefaultBinary = 847;
exports.IdDeleteSubscriptionsResponse = 848;
exports.IdDeleteSubscriptionsResponseEncodingDefaultXml = 849;
exports.IdDeleteSubscriptionsResponseEncodingDefaultBinary = 850;
exports.IdRedundancySupport = 851;
exports.IdServerState = 852;
exports.IdRedundantServerDataType = 853;
exports.IdRedundantServerDataTypeEncodingDefaultXml = 854;
exports.IdRedundantServerDataTypeEncodingDefaultBinary = 855;
exports.IdSamplingIntervalDiagnosticsDataType = 856;
exports.IdSamplingIntervalDiagnosticsDataTypeEncodingDefaultXml = 857;
exports.IdSamplingIntervalDiagnosticsDataTypeEncodingDefaultBinary = 858;
exports.IdServerDiagnosticsSummaryDataType = 859;
exports.IdServerDiagnosticsSummaryDataTypeEncodingDefaultXml = 860;
exports.IdServerDiagnosticsSummaryDataTypeEncodingDefaultBinary = 861;
exports.IdServerStatusDataType = 862;
exports.IdServerStatusDataTypeEncodingDefaultXml = 863;
exports.IdServerStatusDataTypeEncodingDefaultBinary = 864;
exports.IdSessionDiagnosticsDataType = 865;
exports.IdSessionDiagnosticsDataTypeEncodingDefaultXml = 866;
exports.IdSessionDiagnosticsDataTypeEncodingDefaultBinary = 867;
exports.IdSessionSecurityDiagnosticsDataType = 868;
exports.IdSessionSecurityDiagnosticsDataTypeEncodingDefaultXml = 869;
exports.IdSessionSecurityDiagnosticsDataTypeEncodingDefaultBinary = 870;
exports.IdServiceCounterDataType = 871;
exports.IdServiceCounterDataTypeEncodingDefaultXml = 872;
exports.IdServiceCounterDataTypeEncodingDefaultBinary = 873;
exports.IdSubscriptionDiagnosticsDataType = 874;
exports.IdSubscriptionDiagnosticsDataTypeEncodingDefaultXml = 875;
exports.IdSubscriptionDiagnosticsDataTypeEncodingDefaultBinary = 876;
exports.IdModelChangeStructureDataType = 877;
exports.IdModelChangeStructureDataTypeEncodingDefaultXml = 878;
exports.IdModelChangeStructureDataTypeEncodingDefaultBinary = 879;
exports.IdRange = 884;
exports.IdRangeEncodingDefaultXml = 885;
exports.IdRangeEncodingDefaultBinary = 886;
exports.IdEUInformation = 887;
exports.IdEUInformationEncodingDefaultXml = 888;
exports.IdEUInformationEncodingDefaultBinary = 889;
exports.IdExceptionDeviationFormat = 890;
exports.IdAnnotation = 891;
exports.IdAnnotationEncodingDefaultXml = 892;
exports.IdAnnotationEncodingDefaultBinary = 893;
exports.IdProgramDiagnosticDataType = 894;
exports.IdProgramDiagnosticDataTypeEncodingDefaultXml = 895;
exports.IdProgramDiagnosticDataTypeEncodingDefaultBinary = 896;
exports.IdSemanticChangeStructureDataType = 897;
exports.IdSemanticChangeStructureDataTypeEncodingDefaultXml = 898;
exports.IdSemanticChangeStructureDataTypeEncodingDefaultBinary = 899;
exports.IdEventNotificationList = 914;
exports.IdEventNotificationListEncodingDefaultXml = 915;
exports.IdEventNotificationListEncodingDefaultBinary = 916;
exports.IdEventFieldList = 917;
exports.IdEventFieldListEncodingDefaultXml = 918;
exports.IdEventFieldListEncodingDefaultBinary = 919;
exports.IdHistoryEventFieldList = 920;
exports.IdHistoryEventFieldListEncodingDefaultXml = 921;
exports.IdHistoryEventFieldListEncodingDefaultBinary = 922;
exports.IdIssuedIdentityToken = 938;
exports.IdIssuedIdentityTokenEncodingDefaultXml = 939;
exports.IdIssuedIdentityTokenEncodingDefaultBinary = 940;
exports.IdNotificationData = 945;
exports.IdNotificationDataEncodingDefaultXml = 946;
exports.IdNotificationDataEncodingDefaultBinary = 947;
exports.IdAggregateConfiguration = 948;
exports.IdAggregateConfigurationEncodingDefaultXml = 949;
exports.IdAggregateConfigurationEncodingDefaultBinary = 950;
exports.mapIdToName = new Map([
    [1, 'Boolean'],
    [2, 'SByte'],
    [3, 'Byte'],
    [4, 'Int16'],
    [5, 'UInt16'],
    [6, 'Int32'],
    [7, 'UInt32'],
    [8, 'Int64'],
    [9, 'UInt64'],
    [10, 'Float'],
    [11, 'Double'],
    [12, 'String'],
    [13, 'DateTime'],
    [14, 'Guid'],
    [15, 'ByteString'],
    [16, 'XmlElement'],
    [17, 'NodeId'],
    [18, 'ExpandedNodeId'],
    [19, 'StatusCode'],
    [20, 'QualifiedName'],
    [21, 'LocalizedText'],
    [22, 'Structure'],
    [23, 'DataValue'],
    [24, 'BaseDataType'],
    [25, 'DiagnosticInfo'],
    [26, 'Number'],
    [27, 'Integer'],
    [28, 'UInteger'],
    [29, 'Enumeration'],
    [30, 'Image'],
    [31, 'References'],
    [32, 'NonHierarchicalReferences'],
    [33, 'HierarchicalReferences'],
    [34, 'HasChild'],
    [35, 'Organizes'],
    [36, 'HasEventSource'],
    [37, 'HasModellingRule'],
    [38, 'HasEncoding'],
    [39, 'HasDescription'],
    [40, 'HasTypeDefinition'],
    [41, 'GeneratesEvent'],
    [44, 'Aggregates'],
    [45, 'HasSubtype'],
    [46, 'HasProperty'],
    [47, 'HasComponent'],
    [48, 'HasNotifier'],
    [49, 'HasOrderedComponent'],
    [50, 'Decimal'],
    [51, 'FromState'],
    [52, 'ToState'],
    [53, 'HasCause'],
    [54, 'HasEffect'],
    [56, 'HasHistoricalConfiguration'],
    [58, 'BaseObjectType'],
    [61, 'FolderType'],
    [62, 'BaseVariableType'],
    [63, 'BaseDataVariableType'],
    [68, 'PropertyType'],
    [69, 'DataTypeDescriptionType'],
    [72, 'DataTypeDictionaryType'],
    [75, 'DataTypeSystemType'],
    [76, 'DataTypeEncodingType'],
    [77, 'ModellingRuleType'],
    [78, 'ModellingRuleMandatory'],
    [80, 'ModellingRuleOptional'],
    [83, 'ModellingRuleExposesItsArray'],
    [84, 'RootFolder'],
    [85, 'ObjectsFolder'],
    [86, 'TypesFolder'],
    [87, 'ViewsFolder'],
    [88, 'ObjectTypesFolder'],
    [89, 'VariableTypesFolder'],
    [90, 'DataTypesFolder'],
    [91, 'ReferenceTypesFolder'],
    [92, 'XmlSchemaTypeSystem'],
    [93, 'OPCBinarySchemaTypeSystem'],
    [94, 'PermissionType'],
    [95, 'AccessRestrictionType'],
    [96, 'RolePermissionType'],
    [97, 'DataTypeDefinition'],
    [98, 'StructureType'],
    [99, 'StructureDefinition'],
    [100, 'EnumDefinition'],
    [101, 'StructureField'],
    [102, 'EnumField'],
    [104, 'DataTypeDescriptionTypeDataTypeVersion'],
    [105, 'DataTypeDescriptionTypeDictionaryFragment'],
    [106, 'DataTypeDictionaryTypeDataTypeVersion'],
    [107, 'DataTypeDictionaryTypeNamespaceUri'],
    [111, 'ModellingRuleTypeNamingRule'],
    [112, 'ModellingRuleMandatoryNamingRule'],
    [113, 'ModellingRuleOptionalNamingRule'],
    [114, 'ModellingRuleExposesItsArrayNamingRule'],
    [117, 'HasSubStateMachine'],
    [120, 'NamingRuleType'],
    [121, 'DataTypeDefinitionEncodingDefaultBinary'],
    [122, 'StructureDefinitionEncodingDefaultBinary'],
    [123, 'EnumDefinitionEncodingDefaultBinary'],
    [124, 'DataSetMetaDataTypeEncodingDefaultBinary'],
    [125, 'DataTypeDescriptionEncodingDefaultBinary'],
    [126, 'StructureDescriptionEncodingDefaultBinary'],
    [127, 'EnumDescriptionEncodingDefaultBinary'],
    [128, 'RolePermissionTypeEncodingDefaultBinary'],
    [129, 'HasArgumentDescription'],
    [131, 'HasOptionalInputArgumentDescription'],
    [256, 'IdType'],
    [257, 'NodeClass'],
    [258, 'Node'],
    [259, 'NodeEncodingDefaultXml'],
    [260, 'NodeEncodingDefaultBinary'],
    [261, 'ObjectNode'],
    [262, 'ObjectNodeEncodingDefaultXml'],
    [263, 'ObjectNodeEncodingDefaultBinary'],
    [264, 'ObjectTypeNode'],
    [265, 'ObjectTypeNodeEncodingDefaultXml'],
    [266, 'ObjectTypeNodeEncodingDefaultBinary'],
    [267, 'VariableNode'],
    [268, 'VariableNodeEncodingDefaultXml'],
    [269, 'VariableNodeEncodingDefaultBinary'],
    [270, 'VariableTypeNode'],
    [271, 'VariableTypeNodeEncodingDefaultXml'],
    [272, 'VariableTypeNodeEncodingDefaultBinary'],
    [273, 'ReferenceTypeNode'],
    [274, 'ReferenceTypeNodeEncodingDefaultXml'],
    [275, 'ReferenceTypeNodeEncodingDefaultBinary'],
    [276, 'MethodNode'],
    [277, 'MethodNodeEncodingDefaultXml'],
    [278, 'MethodNodeEncodingDefaultBinary'],
    [279, 'ViewNode'],
    [280, 'ViewNodeEncodingDefaultXml'],
    [281, 'ViewNodeEncodingDefaultBinary'],
    [282, 'DataTypeNode'],
    [283, 'DataTypeNodeEncodingDefaultXml'],
    [284, 'DataTypeNodeEncodingDefaultBinary'],
    [285, 'ReferenceNode'],
    [286, 'ReferenceNodeEncodingDefaultXml'],
    [287, 'ReferenceNodeEncodingDefaultBinary'],
    [288, 'IntegerId'],
    [289, 'Counter'],
    [290, 'Duration'],
    [291, 'NumericRange'],
    [292, 'Time'],
    [293, 'Date'],
    [294, 'UtcTime'],
    [295, 'LocaleId'],
    [296, 'Argument'],
    [297, 'ArgumentEncodingDefaultXml'],
    [298, 'ArgumentEncodingDefaultBinary'],
    [299, 'StatusResult'],
    [300, 'StatusResultEncodingDefaultXml'],
    [301, 'StatusResultEncodingDefaultBinary'],
    [302, 'MessageSecurityMode'],
    [303, 'UserTokenType'],
    [304, 'UserTokenPolicy'],
    [305, 'UserTokenPolicyEncodingDefaultXml'],
    [306, 'UserTokenPolicyEncodingDefaultBinary'],
    [307, 'ApplicationType'],
    [308, 'ApplicationDescription'],
    [309, 'ApplicationDescriptionEncodingDefaultXml'],
    [310, 'ApplicationDescriptionEncodingDefaultBinary'],
    [311, 'ApplicationInstanceCertificate'],
    [312, 'EndpointDescription'],
    [313, 'EndpointDescriptionEncodingDefaultXml'],
    [314, 'EndpointDescriptionEncodingDefaultBinary'],
    [315, 'SecurityTokenRequestType'],
    [316, 'UserIdentityToken'],
    [317, 'UserIdentityTokenEncodingDefaultXml'],
    [318, 'UserIdentityTokenEncodingDefaultBinary'],
    [319, 'AnonymousIdentityToken'],
    [320, 'AnonymousIdentityTokenEncodingDefaultXml'],
    [321, 'AnonymousIdentityTokenEncodingDefaultBinary'],
    [322, 'UserNameIdentityToken'],
    [323, 'UserNameIdentityTokenEncodingDefaultXml'],
    [324, 'UserNameIdentityTokenEncodingDefaultBinary'],
    [325, 'X509IdentityToken'],
    [326, 'X509IdentityTokenEncodingDefaultXml'],
    [327, 'X509IdentityTokenEncodingDefaultBinary'],
    [331, 'EndpointConfiguration'],
    [332, 'EndpointConfigurationEncodingDefaultXml'],
    [333, 'EndpointConfigurationEncodingDefaultBinary'],
    [338, 'BuildInfo'],
    [339, 'BuildInfoEncodingDefaultXml'],
    [340, 'BuildInfoEncodingDefaultBinary'],
    [344, 'SignedSoftwareCertificate'],
    [345, 'SignedSoftwareCertificateEncodingDefaultXml'],
    [346, 'SignedSoftwareCertificateEncodingDefaultBinary'],
    [347, 'AttributeWriteMask'],
    [348, 'NodeAttributesMask'],
    [349, 'NodeAttributes'],
    [350, 'NodeAttributesEncodingDefaultXml'],
    [351, 'NodeAttributesEncodingDefaultBinary'],
    [352, 'ObjectAttributes'],
    [353, 'ObjectAttributesEncodingDefaultXml'],
    [354, 'ObjectAttributesEncodingDefaultBinary'],
    [355, 'VariableAttributes'],
    [356, 'VariableAttributesEncodingDefaultXml'],
    [357, 'VariableAttributesEncodingDefaultBinary'],
    [358, 'MethodAttributes'],
    [359, 'MethodAttributesEncodingDefaultXml'],
    [360, 'MethodAttributesEncodingDefaultBinary'],
    [361, 'ObjectTypeAttributes'],
    [362, 'ObjectTypeAttributesEncodingDefaultXml'],
    [363, 'ObjectTypeAttributesEncodingDefaultBinary'],
    [364, 'VariableTypeAttributes'],
    [365, 'VariableTypeAttributesEncodingDefaultXml'],
    [366, 'VariableTypeAttributesEncodingDefaultBinary'],
    [367, 'ReferenceTypeAttributes'],
    [368, 'ReferenceTypeAttributesEncodingDefaultXml'],
    [369, 'ReferenceTypeAttributesEncodingDefaultBinary'],
    [370, 'DataTypeAttributes'],
    [371, 'DataTypeAttributesEncodingDefaultXml'],
    [372, 'DataTypeAttributesEncodingDefaultBinary'],
    [373, 'ViewAttributes'],
    [374, 'ViewAttributesEncodingDefaultXml'],
    [375, 'ViewAttributesEncodingDefaultBinary'],
    [376, 'AddNodesItem'],
    [377, 'AddNodesItemEncodingDefaultXml'],
    [378, 'AddNodesItemEncodingDefaultBinary'],
    [379, 'AddReferencesItem'],
    [380, 'AddReferencesItemEncodingDefaultXml'],
    [381, 'AddReferencesItemEncodingDefaultBinary'],
    [382, 'DeleteNodesItem'],
    [383, 'DeleteNodesItemEncodingDefaultXml'],
    [384, 'DeleteNodesItemEncodingDefaultBinary'],
    [385, 'DeleteReferencesItem'],
    [386, 'DeleteReferencesItemEncodingDefaultXml'],
    [387, 'DeleteReferencesItemEncodingDefaultBinary'],
    [388, 'SessionAuthenticationToken'],
    [389, 'RequestHeader'],
    [390, 'RequestHeaderEncodingDefaultXml'],
    [391, 'RequestHeaderEncodingDefaultBinary'],
    [392, 'ResponseHeader'],
    [393, 'ResponseHeaderEncodingDefaultXml'],
    [394, 'ResponseHeaderEncodingDefaultBinary'],
    [395, 'ServiceFault'],
    [396, 'ServiceFaultEncodingDefaultXml'],
    [397, 'ServiceFaultEncodingDefaultBinary'],
    [420, 'FindServersRequest'],
    [421, 'FindServersRequestEncodingDefaultXml'],
    [422, 'FindServersRequestEncodingDefaultBinary'],
    [423, 'FindServersResponse'],
    [424, 'FindServersResponseEncodingDefaultXml'],
    [425, 'FindServersResponseEncodingDefaultBinary'],
    [426, 'GetEndpointsRequest'],
    [427, 'GetEndpointsRequestEncodingDefaultXml'],
    [428, 'GetEndpointsRequestEncodingDefaultBinary'],
    [429, 'GetEndpointsResponse'],
    [430, 'GetEndpointsResponseEncodingDefaultXml'],
    [431, 'GetEndpointsResponseEncodingDefaultBinary'],
    [432, 'RegisteredServer'],
    [433, 'RegisteredServerEncodingDefaultXml'],
    [434, 'RegisteredServerEncodingDefaultBinary'],
    [435, 'RegisterServerRequest'],
    [436, 'RegisterServerRequestEncodingDefaultXml'],
    [437, 'RegisterServerRequestEncodingDefaultBinary'],
    [438, 'RegisterServerResponse'],
    [439, 'RegisterServerResponseEncodingDefaultXml'],
    [440, 'RegisterServerResponseEncodingDefaultBinary'],
    [441, 'ChannelSecurityToken'],
    [442, 'ChannelSecurityTokenEncodingDefaultXml'],
    [443, 'ChannelSecurityTokenEncodingDefaultBinary'],
    [444, 'OpenSecureChannelRequest'],
    [445, 'OpenSecureChannelRequestEncodingDefaultXml'],
    [446, 'OpenSecureChannelRequestEncodingDefaultBinary'],
    [447, 'OpenSecureChannelResponse'],
    [448, 'OpenSecureChannelResponseEncodingDefaultXml'],
    [449, 'OpenSecureChannelResponseEncodingDefaultBinary'],
    [450, 'CloseSecureChannelRequest'],
    [451, 'CloseSecureChannelRequestEncodingDefaultXml'],
    [452, 'CloseSecureChannelRequestEncodingDefaultBinary'],
    [453, 'CloseSecureChannelResponse'],
    [454, 'CloseSecureChannelResponseEncodingDefaultXml'],
    [455, 'CloseSecureChannelResponseEncodingDefaultBinary'],
    [456, 'SignatureData'],
    [457, 'SignatureDataEncodingDefaultXml'],
    [458, 'SignatureDataEncodingDefaultBinary'],
    [459, 'CreateSessionRequest'],
    [460, 'CreateSessionRequestEncodingDefaultXml'],
    [461, 'CreateSessionRequestEncodingDefaultBinary'],
    [462, 'CreateSessionResponse'],
    [463, 'CreateSessionResponseEncodingDefaultXml'],
    [464, 'CreateSessionResponseEncodingDefaultBinary'],
    [465, 'ActivateSessionRequest'],
    [466, 'ActivateSessionRequestEncodingDefaultXml'],
    [467, 'ActivateSessionRequestEncodingDefaultBinary'],
    [468, 'ActivateSessionResponse'],
    [469, 'ActivateSessionResponseEncodingDefaultXml'],
    [470, 'ActivateSessionResponseEncodingDefaultBinary'],
    [471, 'CloseSessionRequest'],
    [472, 'CloseSessionRequestEncodingDefaultXml'],
    [473, 'CloseSessionRequestEncodingDefaultBinary'],
    [474, 'CloseSessionResponse'],
    [475, 'CloseSessionResponseEncodingDefaultXml'],
    [476, 'CloseSessionResponseEncodingDefaultBinary'],
    [477, 'CancelRequest'],
    [478, 'CancelRequestEncodingDefaultXml'],
    [479, 'CancelRequestEncodingDefaultBinary'],
    [480, 'CancelResponse'],
    [481, 'CancelResponseEncodingDefaultXml'],
    [482, 'CancelResponseEncodingDefaultBinary'],
    [483, 'AddNodesResult'],
    [484, 'AddNodesResultEncodingDefaultXml'],
    [485, 'AddNodesResultEncodingDefaultBinary'],
    [486, 'AddNodesRequest'],
    [487, 'AddNodesRequestEncodingDefaultXml'],
    [488, 'AddNodesRequestEncodingDefaultBinary'],
    [489, 'AddNodesResponse'],
    [490, 'AddNodesResponseEncodingDefaultXml'],
    [491, 'AddNodesResponseEncodingDefaultBinary'],
    [492, 'AddReferencesRequest'],
    [493, 'AddReferencesRequestEncodingDefaultXml'],
    [494, 'AddReferencesRequestEncodingDefaultBinary'],
    [495, 'AddReferencesResponse'],
    [496, 'AddReferencesResponseEncodingDefaultXml'],
    [497, 'AddReferencesResponseEncodingDefaultBinary'],
    [498, 'DeleteNodesRequest'],
    [499, 'DeleteNodesRequestEncodingDefaultXml'],
    [500, 'DeleteNodesRequestEncodingDefaultBinary'],
    [501, 'DeleteNodesResponse'],
    [502, 'DeleteNodesResponseEncodingDefaultXml'],
    [503, 'DeleteNodesResponseEncodingDefaultBinary'],
    [504, 'DeleteReferencesRequest'],
    [505, 'DeleteReferencesRequestEncodingDefaultXml'],
    [506, 'DeleteReferencesRequestEncodingDefaultBinary'],
    [507, 'DeleteReferencesResponse'],
    [508, 'DeleteReferencesResponseEncodingDefaultXml'],
    [509, 'DeleteReferencesResponseEncodingDefaultBinary'],
    [510, 'BrowseDirection'],
    [511, 'ViewDescription'],
    [512, 'ViewDescriptionEncodingDefaultXml'],
    [513, 'ViewDescriptionEncodingDefaultBinary'],
    [514, 'BrowseDescription'],
    [515, 'BrowseDescriptionEncodingDefaultXml'],
    [516, 'BrowseDescriptionEncodingDefaultBinary'],
    [517, 'BrowseResultMask'],
    [518, 'ReferenceDescription'],
    [519, 'ReferenceDescriptionEncodingDefaultXml'],
    [520, 'ReferenceDescriptionEncodingDefaultBinary'],
    [521, 'ContinuationPoint'],
    [522, 'BrowseResult'],
    [523, 'BrowseResultEncodingDefaultXml'],
    [524, 'BrowseResultEncodingDefaultBinary'],
    [525, 'BrowseRequest'],
    [526, 'BrowseRequestEncodingDefaultXml'],
    [527, 'BrowseRequestEncodingDefaultBinary'],
    [528, 'BrowseResponse'],
    [529, 'BrowseResponseEncodingDefaultXml'],
    [530, 'BrowseResponseEncodingDefaultBinary'],
    [531, 'BrowseNextRequest'],
    [532, 'BrowseNextRequestEncodingDefaultXml'],
    [533, 'BrowseNextRequestEncodingDefaultBinary'],
    [534, 'BrowseNextResponse'],
    [535, 'BrowseNextResponseEncodingDefaultXml'],
    [536, 'BrowseNextResponseEncodingDefaultBinary'],
    [537, 'RelativePathElement'],
    [538, 'RelativePathElementEncodingDefaultXml'],
    [539, 'RelativePathElementEncodingDefaultBinary'],
    [540, 'RelativePath'],
    [541, 'RelativePathEncodingDefaultXml'],
    [542, 'RelativePathEncodingDefaultBinary'],
    [543, 'BrowsePath'],
    [544, 'BrowsePathEncodingDefaultXml'],
    [545, 'BrowsePathEncodingDefaultBinary'],
    [546, 'BrowsePathTarget'],
    [547, 'BrowsePathTargetEncodingDefaultXml'],
    [548, 'BrowsePathTargetEncodingDefaultBinary'],
    [549, 'BrowsePathResult'],
    [550, 'BrowsePathResultEncodingDefaultXml'],
    [551, 'BrowsePathResultEncodingDefaultBinary'],
    [552, 'TranslateBrowsePathsToNodeIdsRequest'],
    [553, 'TranslateBrowsePathsToNodeIdsRequestEncodingDefaultXml'],
    [554, 'TranslateBrowsePathsToNodeIdsRequestEncodingDefaultBinary'],
    [555, 'TranslateBrowsePathsToNodeIdsResponse'],
    [556, 'TranslateBrowsePathsToNodeIdsResponseEncodingDefaultXml'],
    [557, 'TranslateBrowsePathsToNodeIdsResponseEncodingDefaultBinary'],
    [558, 'RegisterNodesRequest'],
    [559, 'RegisterNodesRequestEncodingDefaultXml'],
    [560, 'RegisterNodesRequestEncodingDefaultBinary'],
    [561, 'RegisterNodesResponse'],
    [562, 'RegisterNodesResponseEncodingDefaultXml'],
    [563, 'RegisterNodesResponseEncodingDefaultBinary'],
    [564, 'UnregisterNodesRequest'],
    [565, 'UnregisterNodesRequestEncodingDefaultXml'],
    [566, 'UnregisterNodesRequestEncodingDefaultBinary'],
    [567, 'UnregisterNodesResponse'],
    [568, 'UnregisterNodesResponseEncodingDefaultXml'],
    [569, 'UnregisterNodesResponseEncodingDefaultBinary'],
    [570, 'QueryDataDescription'],
    [571, 'QueryDataDescriptionEncodingDefaultXml'],
    [572, 'QueryDataDescriptionEncodingDefaultBinary'],
    [573, 'NodeTypeDescription'],
    [574, 'NodeTypeDescriptionEncodingDefaultXml'],
    [575, 'NodeTypeDescriptionEncodingDefaultBinary'],
    [576, 'FilterOperator'],
    [577, 'QueryDataSet'],
    [578, 'QueryDataSetEncodingDefaultXml'],
    [579, 'QueryDataSetEncodingDefaultBinary'],
    [580, 'NodeReference'],
    [581, 'NodeReferenceEncodingDefaultXml'],
    [582, 'NodeReferenceEncodingDefaultBinary'],
    [583, 'ContentFilterElement'],
    [584, 'ContentFilterElementEncodingDefaultXml'],
    [585, 'ContentFilterElementEncodingDefaultBinary'],
    [586, 'ContentFilter'],
    [587, 'ContentFilterEncodingDefaultXml'],
    [588, 'ContentFilterEncodingDefaultBinary'],
    [589, 'FilterOperand'],
    [590, 'FilterOperandEncodingDefaultXml'],
    [591, 'FilterOperandEncodingDefaultBinary'],
    [592, 'ElementOperand'],
    [593, 'ElementOperandEncodingDefaultXml'],
    [594, 'ElementOperandEncodingDefaultBinary'],
    [595, 'LiteralOperand'],
    [596, 'LiteralOperandEncodingDefaultXml'],
    [597, 'LiteralOperandEncodingDefaultBinary'],
    [598, 'AttributeOperand'],
    [599, 'AttributeOperandEncodingDefaultXml'],
    [600, 'AttributeOperandEncodingDefaultBinary'],
    [601, 'SimpleAttributeOperand'],
    [602, 'SimpleAttributeOperandEncodingDefaultXml'],
    [603, 'SimpleAttributeOperandEncodingDefaultBinary'],
    [604, 'ContentFilterElementResult'],
    [605, 'ContentFilterElementResultEncodingDefaultXml'],
    [606, 'ContentFilterElementResultEncodingDefaultBinary'],
    [607, 'ContentFilterResult'],
    [608, 'ContentFilterResultEncodingDefaultXml'],
    [609, 'ContentFilterResultEncodingDefaultBinary'],
    [610, 'ParsingResult'],
    [611, 'ParsingResultEncodingDefaultXml'],
    [612, 'ParsingResultEncodingDefaultBinary'],
    [613, 'QueryFirstRequest'],
    [614, 'QueryFirstRequestEncodingDefaultXml'],
    [615, 'QueryFirstRequestEncodingDefaultBinary'],
    [616, 'QueryFirstResponse'],
    [617, 'QueryFirstResponseEncodingDefaultXml'],
    [618, 'QueryFirstResponseEncodingDefaultBinary'],
    [619, 'QueryNextRequest'],
    [620, 'QueryNextRequestEncodingDefaultXml'],
    [621, 'QueryNextRequestEncodingDefaultBinary'],
    [622, 'QueryNextResponse'],
    [623, 'QueryNextResponseEncodingDefaultXml'],
    [624, 'QueryNextResponseEncodingDefaultBinary'],
    [625, 'TimestampsToReturn'],
    [626, 'ReadValueId'],
    [627, 'ReadValueIdEncodingDefaultXml'],
    [628, 'ReadValueIdEncodingDefaultBinary'],
    [629, 'ReadRequest'],
    [630, 'ReadRequestEncodingDefaultXml'],
    [631, 'ReadRequestEncodingDefaultBinary'],
    [632, 'ReadResponse'],
    [633, 'ReadResponseEncodingDefaultXml'],
    [634, 'ReadResponseEncodingDefaultBinary'],
    [635, 'HistoryReadValueId'],
    [636, 'HistoryReadValueIdEncodingDefaultXml'],
    [637, 'HistoryReadValueIdEncodingDefaultBinary'],
    [638, 'HistoryReadResult'],
    [639, 'HistoryReadResultEncodingDefaultXml'],
    [640, 'HistoryReadResultEncodingDefaultBinary'],
    [641, 'HistoryReadDetails'],
    [642, 'HistoryReadDetailsEncodingDefaultXml'],
    [643, 'HistoryReadDetailsEncodingDefaultBinary'],
    [644, 'ReadEventDetails'],
    [645, 'ReadEventDetailsEncodingDefaultXml'],
    [646, 'ReadEventDetailsEncodingDefaultBinary'],
    [647, 'ReadRawModifiedDetails'],
    [648, 'ReadRawModifiedDetailsEncodingDefaultXml'],
    [649, 'ReadRawModifiedDetailsEncodingDefaultBinary'],
    [650, 'ReadProcessedDetails'],
    [651, 'ReadProcessedDetailsEncodingDefaultXml'],
    [652, 'ReadProcessedDetailsEncodingDefaultBinary'],
    [653, 'ReadAtTimeDetails'],
    [654, 'ReadAtTimeDetailsEncodingDefaultXml'],
    [655, 'ReadAtTimeDetailsEncodingDefaultBinary'],
    [656, 'HistoryData'],
    [657, 'HistoryDataEncodingDefaultXml'],
    [658, 'HistoryDataEncodingDefaultBinary'],
    [659, 'HistoryEvent'],
    [660, 'HistoryEventEncodingDefaultXml'],
    [661, 'HistoryEventEncodingDefaultBinary'],
    [662, 'HistoryReadRequest'],
    [663, 'HistoryReadRequestEncodingDefaultXml'],
    [664, 'HistoryReadRequestEncodingDefaultBinary'],
    [665, 'HistoryReadResponse'],
    [666, 'HistoryReadResponseEncodingDefaultXml'],
    [667, 'HistoryReadResponseEncodingDefaultBinary'],
    [668, 'WriteValue'],
    [669, 'WriteValueEncodingDefaultXml'],
    [670, 'WriteValueEncodingDefaultBinary'],
    [671, 'WriteRequest'],
    [672, 'WriteRequestEncodingDefaultXml'],
    [673, 'WriteRequestEncodingDefaultBinary'],
    [674, 'WriteResponse'],
    [675, 'WriteResponseEncodingDefaultXml'],
    [676, 'WriteResponseEncodingDefaultBinary'],
    [677, 'HistoryUpdateDetails'],
    [678, 'HistoryUpdateDetailsEncodingDefaultXml'],
    [679, 'HistoryUpdateDetailsEncodingDefaultBinary'],
    [680, 'UpdateDataDetails'],
    [681, 'UpdateDataDetailsEncodingDefaultXml'],
    [682, 'UpdateDataDetailsEncodingDefaultBinary'],
    [683, 'UpdateEventDetails'],
    [684, 'UpdateEventDetailsEncodingDefaultXml'],
    [685, 'UpdateEventDetailsEncodingDefaultBinary'],
    [686, 'DeleteRawModifiedDetails'],
    [687, 'DeleteRawModifiedDetailsEncodingDefaultXml'],
    [688, 'DeleteRawModifiedDetailsEncodingDefaultBinary'],
    [689, 'DeleteAtTimeDetails'],
    [690, 'DeleteAtTimeDetailsEncodingDefaultXml'],
    [691, 'DeleteAtTimeDetailsEncodingDefaultBinary'],
    [692, 'DeleteEventDetails'],
    [693, 'DeleteEventDetailsEncodingDefaultXml'],
    [694, 'DeleteEventDetailsEncodingDefaultBinary'],
    [695, 'HistoryUpdateResult'],
    [696, 'HistoryUpdateResultEncodingDefaultXml'],
    [697, 'HistoryUpdateResultEncodingDefaultBinary'],
    [698, 'HistoryUpdateRequest'],
    [699, 'HistoryUpdateRequestEncodingDefaultXml'],
    [700, 'HistoryUpdateRequestEncodingDefaultBinary'],
    [701, 'HistoryUpdateResponse'],
    [702, 'HistoryUpdateResponseEncodingDefaultXml'],
    [703, 'HistoryUpdateResponseEncodingDefaultBinary'],
    [704, 'CallMethodRequest'],
    [705, 'CallMethodRequestEncodingDefaultXml'],
    [706, 'CallMethodRequestEncodingDefaultBinary'],
    [707, 'CallMethodResult'],
    [708, 'CallMethodResultEncodingDefaultXml'],
    [709, 'CallMethodResultEncodingDefaultBinary'],
    [710, 'CallRequest'],
    [711, 'CallRequestEncodingDefaultXml'],
    [712, 'CallRequestEncodingDefaultBinary'],
    [713, 'CallResponse'],
    [714, 'CallResponseEncodingDefaultXml'],
    [715, 'CallResponseEncodingDefaultBinary'],
    [716, 'MonitoringMode'],
    [717, 'DataChangeTrigger'],
    [718, 'DeadbandType'],
    [719, 'MonitoringFilter'],
    [720, 'MonitoringFilterEncodingDefaultXml'],
    [721, 'MonitoringFilterEncodingDefaultBinary'],
    [722, 'DataChangeFilter'],
    [723, 'DataChangeFilterEncodingDefaultXml'],
    [724, 'DataChangeFilterEncodingDefaultBinary'],
    [725, 'EventFilter'],
    [726, 'EventFilterEncodingDefaultXml'],
    [727, 'EventFilterEncodingDefaultBinary'],
    [728, 'AggregateFilter'],
    [729, 'AggregateFilterEncodingDefaultXml'],
    [730, 'AggregateFilterEncodingDefaultBinary'],
    [731, 'MonitoringFilterResult'],
    [732, 'MonitoringFilterResultEncodingDefaultXml'],
    [733, 'MonitoringFilterResultEncodingDefaultBinary'],
    [734, 'EventFilterResult'],
    [735, 'EventFilterResultEncodingDefaultXml'],
    [736, 'EventFilterResultEncodingDefaultBinary'],
    [737, 'AggregateFilterResult'],
    [738, 'AggregateFilterResultEncodingDefaultXml'],
    [739, 'AggregateFilterResultEncodingDefaultBinary'],
    [740, 'MonitoringParameters'],
    [741, 'MonitoringParametersEncodingDefaultXml'],
    [742, 'MonitoringParametersEncodingDefaultBinary'],
    [743, 'MonitoredItemCreateRequest'],
    [744, 'MonitoredItemCreateRequestEncodingDefaultXml'],
    [745, 'MonitoredItemCreateRequestEncodingDefaultBinary'],
    [746, 'MonitoredItemCreateResult'],
    [747, 'MonitoredItemCreateResultEncodingDefaultXml'],
    [748, 'MonitoredItemCreateResultEncodingDefaultBinary'],
    [749, 'CreateMonitoredItemsRequest'],
    [750, 'CreateMonitoredItemsRequestEncodingDefaultXml'],
    [751, 'CreateMonitoredItemsRequestEncodingDefaultBinary'],
    [752, 'CreateMonitoredItemsResponse'],
    [753, 'CreateMonitoredItemsResponseEncodingDefaultXml'],
    [754, 'CreateMonitoredItemsResponseEncodingDefaultBinary'],
    [755, 'MonitoredItemModifyRequest'],
    [756, 'MonitoredItemModifyRequestEncodingDefaultXml'],
    [757, 'MonitoredItemModifyRequestEncodingDefaultBinary'],
    [758, 'MonitoredItemModifyResult'],
    [759, 'MonitoredItemModifyResultEncodingDefaultXml'],
    [760, 'MonitoredItemModifyResultEncodingDefaultBinary'],
    [761, 'ModifyMonitoredItemsRequest'],
    [762, 'ModifyMonitoredItemsRequestEncodingDefaultXml'],
    [763, 'ModifyMonitoredItemsRequestEncodingDefaultBinary'],
    [764, 'ModifyMonitoredItemsResponse'],
    [765, 'ModifyMonitoredItemsResponseEncodingDefaultXml'],
    [766, 'ModifyMonitoredItemsResponseEncodingDefaultBinary'],
    [767, 'SetMonitoringModeRequest'],
    [768, 'SetMonitoringModeRequestEncodingDefaultXml'],
    [769, 'SetMonitoringModeRequestEncodingDefaultBinary'],
    [770, 'SetMonitoringModeResponse'],
    [771, 'SetMonitoringModeResponseEncodingDefaultXml'],
    [772, 'SetMonitoringModeResponseEncodingDefaultBinary'],
    [773, 'SetTriggeringRequest'],
    [774, 'SetTriggeringRequestEncodingDefaultXml'],
    [775, 'SetTriggeringRequestEncodingDefaultBinary'],
    [776, 'SetTriggeringResponse'],
    [777, 'SetTriggeringResponseEncodingDefaultXml'],
    [778, 'SetTriggeringResponseEncodingDefaultBinary'],
    [779, 'DeleteMonitoredItemsRequest'],
    [780, 'DeleteMonitoredItemsRequestEncodingDefaultXml'],
    [781, 'DeleteMonitoredItemsRequestEncodingDefaultBinary'],
    [782, 'DeleteMonitoredItemsResponse'],
    [783, 'DeleteMonitoredItemsResponseEncodingDefaultXml'],
    [784, 'DeleteMonitoredItemsResponseEncodingDefaultBinary'],
    [785, 'CreateSubscriptionRequest'],
    [786, 'CreateSubscriptionRequestEncodingDefaultXml'],
    [787, 'CreateSubscriptionRequestEncodingDefaultBinary'],
    [788, 'CreateSubscriptionResponse'],
    [789, 'CreateSubscriptionResponseEncodingDefaultXml'],
    [790, 'CreateSubscriptionResponseEncodingDefaultBinary'],
    [791, 'ModifySubscriptionRequest'],
    [792, 'ModifySubscriptionRequestEncodingDefaultXml'],
    [793, 'ModifySubscriptionRequestEncodingDefaultBinary'],
    [794, 'ModifySubscriptionResponse'],
    [795, 'ModifySubscriptionResponseEncodingDefaultXml'],
    [796, 'ModifySubscriptionResponseEncodingDefaultBinary'],
    [797, 'SetPublishingModeRequest'],
    [798, 'SetPublishingModeRequestEncodingDefaultXml'],
    [799, 'SetPublishingModeRequestEncodingDefaultBinary'],
    [800, 'SetPublishingModeResponse'],
    [801, 'SetPublishingModeResponseEncodingDefaultXml'],
    [802, 'SetPublishingModeResponseEncodingDefaultBinary'],
    [803, 'NotificationMessage'],
    [804, 'NotificationMessageEncodingDefaultXml'],
    [805, 'NotificationMessageEncodingDefaultBinary'],
    [806, 'MonitoredItemNotification'],
    [807, 'MonitoredItemNotificationEncodingDefaultXml'],
    [808, 'MonitoredItemNotificationEncodingDefaultBinary'],
    [809, 'DataChangeNotification'],
    [810, 'DataChangeNotificationEncodingDefaultXml'],
    [811, 'DataChangeNotificationEncodingDefaultBinary'],
    [818, 'StatusChangeNotification'],
    [819, 'StatusChangeNotificationEncodingDefaultXml'],
    [820, 'StatusChangeNotificationEncodingDefaultBinary'],
    [821, 'SubscriptionAcknowledgement'],
    [822, 'SubscriptionAcknowledgementEncodingDefaultXml'],
    [823, 'SubscriptionAcknowledgementEncodingDefaultBinary'],
    [824, 'PublishRequest'],
    [825, 'PublishRequestEncodingDefaultXml'],
    [826, 'PublishRequestEncodingDefaultBinary'],
    [827, 'PublishResponse'],
    [828, 'PublishResponseEncodingDefaultXml'],
    [829, 'PublishResponseEncodingDefaultBinary'],
    [830, 'RepublishRequest'],
    [831, 'RepublishRequestEncodingDefaultXml'],
    [832, 'RepublishRequestEncodingDefaultBinary'],
    [833, 'RepublishResponse'],
    [834, 'RepublishResponseEncodingDefaultXml'],
    [835, 'RepublishResponseEncodingDefaultBinary'],
    [836, 'TransferResult'],
    [837, 'TransferResultEncodingDefaultXml'],
    [838, 'TransferResultEncodingDefaultBinary'],
    [839, 'TransferSubscriptionsRequest'],
    [840, 'TransferSubscriptionsRequestEncodingDefaultXml'],
    [841, 'TransferSubscriptionsRequestEncodingDefaultBinary'],
    [842, 'TransferSubscriptionsResponse'],
    [843, 'TransferSubscriptionsResponseEncodingDefaultXml'],
    [844, 'TransferSubscriptionsResponseEncodingDefaultBinary'],
    [845, 'DeleteSubscriptionsRequest'],
    [846, 'DeleteSubscriptionsRequestEncodingDefaultXml'],
    [847, 'DeleteSubscriptionsRequestEncodingDefaultBinary'],
    [848, 'DeleteSubscriptionsResponse'],
    [849, 'DeleteSubscriptionsResponseEncodingDefaultXml'],
    [850, 'DeleteSubscriptionsResponseEncodingDefaultBinary'],
    [851, 'RedundancySupport'],
    [852, 'ServerState'],
    [853, 'RedundantServerDataType'],
    [854, 'RedundantServerDataTypeEncodingDefaultXml'],
    [855, 'RedundantServerDataTypeEncodingDefaultBinary'],
    [856, 'SamplingIntervalDiagnosticsDataType'],
    [857, 'SamplingIntervalDiagnosticsDataTypeEncodingDefaultXml'],
    [858, 'SamplingIntervalDiagnosticsDataTypeEncodingDefaultBinary'],
    [859, 'ServerDiagnosticsSummaryDataType'],
    [860, 'ServerDiagnosticsSummaryDataTypeEncodingDefaultXml'],
    [861, 'ServerDiagnosticsSummaryDataTypeEncodingDefaultBinary'],
    [862, 'ServerStatusDataType'],
    [863, 'ServerStatusDataTypeEncodingDefaultXml'],
    [864, 'ServerStatusDataTypeEncodingDefaultBinary'],
    [865, 'SessionDiagnosticsDataType'],
    [866, 'SessionDiagnosticsDataTypeEncodingDefaultXml'],
    [867, 'SessionDiagnosticsDataTypeEncodingDefaultBinary'],
    [868, 'SessionSecurityDiagnosticsDataType'],
    [869, 'SessionSecurityDiagnosticsDataTypeEncodingDefaultXml'],
    [870, 'SessionSecurityDiagnosticsDataTypeEncodingDefaultBinary'],
    [871, 'ServiceCounterDataType'],
    [872, 'ServiceCounterDataTypeEncodingDefaultXml'],
    [873, 'ServiceCounterDataTypeEncodingDefaultBinary'],
    [874, 'SubscriptionDiagnosticsDataType'],
    [875, 'SubscriptionDiagnosticsDataTypeEncodingDefaultXml'],
    [876, 'SubscriptionDiagnosticsDataTypeEncodingDefaultBinary'],
    [877, 'ModelChangeStructureDataType'],
    [878, 'ModelChangeStructureDataTypeEncodingDefaultXml'],
    [879, 'ModelChangeStructureDataTypeEncodingDefaultBinary'],
    [884, 'Range'],
    [885, 'RangeEncodingDefaultXml'],
    [886, 'RangeEncodingDefaultBinary'],
    [887, 'EUInformation'],
    [888, 'EUInformationEncodingDefaultXml'],
    [889, 'EUInformationEncodingDefaultBinary'],
    [890, 'ExceptionDeviationFormat'],
    [891, 'Annotation'],
    [892, 'AnnotationEncodingDefaultXml'],
    [893, 'AnnotationEncodingDefaultBinary'],
    [894, 'ProgramDiagnosticDataType'],
    [895, 'ProgramDiagnosticDataTypeEncodingDefaultXml'],
    [896, 'ProgramDiagnosticDataTypeEncodingDefaultBinary'],
    [897, 'SemanticChangeStructureDataType'],
    [898, 'SemanticChangeStructureDataTypeEncodingDefaultXml'],
    [899, 'SemanticChangeStructureDataTypeEncodingDefaultBinary'],
    [914, 'EventNotificationList'],
    [915, 'EventNotificationListEncodingDefaultXml'],
    [916, 'EventNotificationListEncodingDefaultBinary'],
    [917, 'EventFieldList'],
    [918, 'EventFieldListEncodingDefaultXml'],
    [919, 'EventFieldListEncodingDefaultBinary'],
    [920, 'HistoryEventFieldList'],
    [921, 'HistoryEventFieldListEncodingDefaultXml'],
    [922, 'HistoryEventFieldListEncodingDefaultBinary'],
    [938, 'IssuedIdentityToken'],
    [939, 'IssuedIdentityTokenEncodingDefaultXml'],
    [940, 'IssuedIdentityTokenEncodingDefaultBinary'],
    [945, 'NotificationData'],
    [946, 'NotificationDataEncodingDefaultXml'],
    [947, 'NotificationDataEncodingDefaultBinary'],
    [948, 'AggregateConfiguration'],
    [949, 'AggregateConfigurationEncodingDefaultXml'],
    [950, 'AggregateConfigurationEncodingDefaultBinary']
]);
exports.mapNameToId = new Map([
    ['Boolean', 1],
    ['SByte', 2],
    ['Byte', 3],
    ['Int16', 4],
    ['UInt16', 5],
    ['Int32', 6],
    ['UInt32', 7],
    ['Int64', 8],
    ['UInt64', 9],
    ['Float', 10],
    ['Double', 11],
    ['String', 12],
    ['DateTime', 13],
    ['Guid', 14],
    ['ByteString', 15],
    ['XmlElement', 16],
    ['NodeId', 17],
    ['ExpandedNodeId', 18],
    ['StatusCode', 19],
    ['QualifiedName', 20],
    ['LocalizedText', 21],
    ['Structure', 22],
    ['DataValue', 23],
    ['BaseDataType', 24],
    ['DiagnosticInfo', 25],
    ['Number', 26],
    ['Integer', 27],
    ['UInteger', 28],
    ['Enumeration', 29],
    ['Image', 30],
    ['References', 31],
    ['NonHierarchicalReferences', 32],
    ['HierarchicalReferences', 33],
    ['HasChild', 34],
    ['Organizes', 35],
    ['HasEventSource', 36],
    ['HasModellingRule', 37],
    ['HasEncoding', 38],
    ['HasDescription', 39],
    ['HasTypeDefinition', 40],
    ['GeneratesEvent', 41],
    ['Aggregates', 44],
    ['HasSubtype', 45],
    ['HasProperty', 46],
    ['HasComponent', 47],
    ['HasNotifier', 48],
    ['HasOrderedComponent', 49],
    ['Decimal', 50],
    ['FromState', 51],
    ['ToState', 52],
    ['HasCause', 53],
    ['HasEffect', 54],
    ['HasHistoricalConfiguration', 56],
    ['BaseObjectType', 58],
    ['FolderType', 61],
    ['BaseVariableType', 62],
    ['BaseDataVariableType', 63],
    ['PropertyType', 68],
    ['DataTypeDescriptionType', 69],
    ['DataTypeDictionaryType', 72],
    ['DataTypeSystemType', 75],
    ['DataTypeEncodingType', 76],
    ['ModellingRuleType', 77],
    ['ModellingRuleMandatory', 78],
    ['ModellingRuleOptional', 80],
    ['ModellingRuleExposesItsArray', 83],
    ['RootFolder', 84],
    ['ObjectsFolder', 85],
    ['TypesFolder', 86],
    ['ViewsFolder', 87],
    ['ObjectTypesFolder', 88],
    ['VariableTypesFolder', 89],
    ['DataTypesFolder', 90],
    ['ReferenceTypesFolder', 91],
    ['XmlSchemaTypeSystem', 92],
    ['OPCBinarySchemaTypeSystem', 93],
    ['PermissionType', 94],
    ['AccessRestrictionType', 95],
    ['RolePermissionType', 96],
    ['DataTypeDefinition', 97],
    ['StructureType', 98],
    ['StructureDefinition', 99],
    ['EnumDefinition', 100],
    ['StructureField', 101],
    ['EnumField', 102],
    ['DataTypeDescriptionTypeDataTypeVersion', 104],
    ['DataTypeDescriptionTypeDictionaryFragment', 105],
    ['DataTypeDictionaryTypeDataTypeVersion', 106],
    ['DataTypeDictionaryTypeNamespaceUri', 107],
    ['ModellingRuleTypeNamingRule', 111],
    ['ModellingRuleMandatoryNamingRule', 112],
    ['ModellingRuleOptionalNamingRule', 113],
    ['ModellingRuleExposesItsArrayNamingRule', 114],
    ['HasSubStateMachine', 117],
    ['NamingRuleType', 120],
    ['DataTypeDefinitionEncodingDefaultBinary', 121],
    ['StructureDefinitionEncodingDefaultBinary', 122],
    ['EnumDefinitionEncodingDefaultBinary', 123],
    ['DataSetMetaDataTypeEncodingDefaultBinary', 124],
    ['DataTypeDescriptionEncodingDefaultBinary', 125],
    ['StructureDescriptionEncodingDefaultBinary', 126],
    ['EnumDescriptionEncodingDefaultBinary', 127],
    ['RolePermissionTypeEncodingDefaultBinary', 128],
    ['HasArgumentDescription', 129],
    ['HasOptionalInputArgumentDescription', 131],
    ['IdType', 256],
    ['NodeClass', 257],
    ['Node', 258],
    ['NodeEncodingDefaultXml', 259],
    ['NodeEncodingDefaultBinary', 260],
    ['ObjectNode', 261],
    ['ObjectNodeEncodingDefaultXml', 262],
    ['ObjectNodeEncodingDefaultBinary', 263],
    ['ObjectTypeNode', 264],
    ['ObjectTypeNodeEncodingDefaultXml', 265],
    ['ObjectTypeNodeEncodingDefaultBinary', 266],
    ['VariableNode', 267],
    ['VariableNodeEncodingDefaultXml', 268],
    ['VariableNodeEncodingDefaultBinary', 269],
    ['VariableTypeNode', 270],
    ['VariableTypeNodeEncodingDefaultXml', 271],
    ['VariableTypeNodeEncodingDefaultBinary', 272],
    ['ReferenceTypeNode', 273],
    ['ReferenceTypeNodeEncodingDefaultXml', 274],
    ['ReferenceTypeNodeEncodingDefaultBinary', 275],
    ['MethodNode', 276],
    ['MethodNodeEncodingDefaultXml', 277],
    ['MethodNodeEncodingDefaultBinary', 278],
    ['ViewNode', 279],
    ['ViewNodeEncodingDefaultXml', 280],
    ['ViewNodeEncodingDefaultBinary', 281],
    ['DataTypeNode', 282],
    ['DataTypeNodeEncodingDefaultXml', 283],
    ['DataTypeNodeEncodingDefaultBinary', 284],
    ['ReferenceNode', 285],
    ['ReferenceNodeEncodingDefaultXml', 286],
    ['ReferenceNodeEncodingDefaultBinary', 287],
    ['IntegerId', 288],
    ['Counter', 289],
    ['Duration', 290],
    ['NumericRange', 291],
    ['Time', 292],
    ['Date', 293],
    ['UtcTime', 294],
    ['LocaleId', 295],
    ['Argument', 296],
    ['ArgumentEncodingDefaultXml', 297],
    ['ArgumentEncodingDefaultBinary', 298],
    ['StatusResult', 299],
    ['StatusResultEncodingDefaultXml', 300],
    ['StatusResultEncodingDefaultBinary', 301],
    ['MessageSecurityMode', 302],
    ['UserTokenType', 303],
    ['UserTokenPolicy', 304],
    ['UserTokenPolicyEncodingDefaultXml', 305],
    ['UserTokenPolicyEncodingDefaultBinary', 306],
    ['ApplicationType', 307],
    ['ApplicationDescription', 308],
    ['ApplicationDescriptionEncodingDefaultXml', 309],
    ['ApplicationDescriptionEncodingDefaultBinary', 310],
    ['ApplicationInstanceCertificate', 311],
    ['EndpointDescription', 312],
    ['EndpointDescriptionEncodingDefaultXml', 313],
    ['EndpointDescriptionEncodingDefaultBinary', 314],
    ['SecurityTokenRequestType', 315],
    ['UserIdentityToken', 316],
    ['UserIdentityTokenEncodingDefaultXml', 317],
    ['UserIdentityTokenEncodingDefaultBinary', 318],
    ['AnonymousIdentityToken', 319],
    ['AnonymousIdentityTokenEncodingDefaultXml', 320],
    ['AnonymousIdentityTokenEncodingDefaultBinary', 321],
    ['UserNameIdentityToken', 322],
    ['UserNameIdentityTokenEncodingDefaultXml', 323],
    ['UserNameIdentityTokenEncodingDefaultBinary', 324],
    ['X509IdentityToken', 325],
    ['X509IdentityTokenEncodingDefaultXml', 326],
    ['X509IdentityTokenEncodingDefaultBinary', 327],
    ['EndpointConfiguration', 331],
    ['EndpointConfigurationEncodingDefaultXml', 332],
    ['EndpointConfigurationEncodingDefaultBinary', 333],
    ['BuildInfo', 338],
    ['BuildInfoEncodingDefaultXml', 339],
    ['BuildInfoEncodingDefaultBinary', 340],
    ['SignedSoftwareCertificate', 344],
    ['SignedSoftwareCertificateEncodingDefaultXml', 345],
    ['SignedSoftwareCertificateEncodingDefaultBinary', 346],
    ['AttributeWriteMask', 347],
    ['NodeAttributesMask', 348],
    ['NodeAttributes', 349],
    ['NodeAttributesEncodingDefaultXml', 350],
    ['NodeAttributesEncodingDefaultBinary', 351],
    ['ObjectAttributes', 352],
    ['ObjectAttributesEncodingDefaultXml', 353],
    ['ObjectAttributesEncodingDefaultBinary', 354],
    ['VariableAttributes', 355],
    ['VariableAttributesEncodingDefaultXml', 356],
    ['VariableAttributesEncodingDefaultBinary', 357],
    ['MethodAttributes', 358],
    ['MethodAttributesEncodingDefaultXml', 359],
    ['MethodAttributesEncodingDefaultBinary', 360],
    ['ObjectTypeAttributes', 361],
    ['ObjectTypeAttributesEncodingDefaultXml', 362],
    ['ObjectTypeAttributesEncodingDefaultBinary', 363],
    ['VariableTypeAttributes', 364],
    ['VariableTypeAttributesEncodingDefaultXml', 365],
    ['VariableTypeAttributesEncodingDefaultBinary', 366],
    ['ReferenceTypeAttributes', 367],
    ['ReferenceTypeAttributesEncodingDefaultXml', 368],
    ['ReferenceTypeAttributesEncodingDefaultBinary', 369],
    ['DataTypeAttributes', 370],
    ['DataTypeAttributesEncodingDefaultXml', 371],
    ['DataTypeAttributesEncodingDefaultBinary', 372],
    ['ViewAttributes', 373],
    ['ViewAttributesEncodingDefaultXml', 374],
    ['ViewAttributesEncodingDefaultBinary', 375],
    ['AddNodesItem', 376],
    ['AddNodesItemEncodingDefaultXml', 377],
    ['AddNodesItemEncodingDefaultBinary', 378],
    ['AddReferencesItem', 379],
    ['AddReferencesItemEncodingDefaultXml', 380],
    ['AddReferencesItemEncodingDefaultBinary', 381],
    ['DeleteNodesItem', 382],
    ['DeleteNodesItemEncodingDefaultXml', 383],
    ['DeleteNodesItemEncodingDefaultBinary', 384],
    ['DeleteReferencesItem', 385],
    ['DeleteReferencesItemEncodingDefaultXml', 386],
    ['DeleteReferencesItemEncodingDefaultBinary', 387],
    ['SessionAuthenticationToken', 388],
    ['RequestHeader', 389],
    ['RequestHeaderEncodingDefaultXml', 390],
    ['RequestHeaderEncodingDefaultBinary', 391],
    ['ResponseHeader', 392],
    ['ResponseHeaderEncodingDefaultXml', 393],
    ['ResponseHeaderEncodingDefaultBinary', 394],
    ['ServiceFault', 395],
    ['ServiceFaultEncodingDefaultXml', 396],
    ['ServiceFaultEncodingDefaultBinary', 397],
    ['FindServersRequest', 420],
    ['FindServersRequestEncodingDefaultXml', 421],
    ['FindServersRequestEncodingDefaultBinary', 422],
    ['FindServersResponse', 423],
    ['FindServersResponseEncodingDefaultXml', 424],
    ['FindServersResponseEncodingDefaultBinary', 425],
    ['GetEndpointsRequest', 426],
    ['GetEndpointsRequestEncodingDefaultXml', 427],
    ['GetEndpointsRequestEncodingDefaultBinary', 428],
    ['GetEndpointsResponse', 429],
    ['GetEndpointsResponseEncodingDefaultXml', 430],
    ['GetEndpointsResponseEncodingDefaultBinary', 431],
    ['RegisteredServer', 432],
    ['RegisteredServerEncodingDefaultXml', 433],
    ['RegisteredServerEncodingDefaultBinary', 434],
    ['RegisterServerRequest', 435],
    ['RegisterServerRequestEncodingDefaultXml', 436],
    ['RegisterServerRequestEncodingDefaultBinary', 437],
    ['RegisterServerResponse', 438],
    ['RegisterServerResponseEncodingDefaultXml', 439],
    ['RegisterServerResponseEncodingDefaultBinary', 440],
    ['ChannelSecurityToken', 441],
    ['ChannelSecurityTokenEncodingDefaultXml', 442],
    ['ChannelSecurityTokenEncodingDefaultBinary', 443],
    ['OpenSecureChannelRequest', 444],
    ['OpenSecureChannelRequestEncodingDefaultXml', 445],
    ['OpenSecureChannelRequestEncodingDefaultBinary', 446],
    ['OpenSecureChannelResponse', 447],
    ['OpenSecureChannelResponseEncodingDefaultXml', 448],
    ['OpenSecureChannelResponseEncodingDefaultBinary', 449],
    ['CloseSecureChannelRequest', 450],
    ['CloseSecureChannelRequestEncodingDefaultXml', 451],
    ['CloseSecureChannelRequestEncodingDefaultBinary', 452],
    ['CloseSecureChannelResponse', 453],
    ['CloseSecureChannelResponseEncodingDefaultXml', 454],
    ['CloseSecureChannelResponseEncodingDefaultBinary', 455],
    ['SignatureData', 456],
    ['SignatureDataEncodingDefaultXml', 457],
    ['SignatureDataEncodingDefaultBinary', 458],
    ['CreateSessionRequest', 459],
    ['CreateSessionRequestEncodingDefaultXml', 460],
    ['CreateSessionRequestEncodingDefaultBinary', 461],
    ['CreateSessionResponse', 462],
    ['CreateSessionResponseEncodingDefaultXml', 463],
    ['CreateSessionResponseEncodingDefaultBinary', 464],
    ['ActivateSessionRequest', 465],
    ['ActivateSessionRequestEncodingDefaultXml', 466],
    ['ActivateSessionRequestEncodingDefaultBinary', 467],
    ['ActivateSessionResponse', 468],
    ['ActivateSessionResponseEncodingDefaultXml', 469],
    ['ActivateSessionResponseEncodingDefaultBinary', 470],
    ['CloseSessionRequest', 471],
    ['CloseSessionRequestEncodingDefaultXml', 472],
    ['CloseSessionRequestEncodingDefaultBinary', 473],
    ['CloseSessionResponse', 474],
    ['CloseSessionResponseEncodingDefaultXml', 475],
    ['CloseSessionResponseEncodingDefaultBinary', 476],
    ['CancelRequest', 477],
    ['CancelRequestEncodingDefaultXml', 478],
    ['CancelRequestEncodingDefaultBinary', 479],
    ['CancelResponse', 480],
    ['CancelResponseEncodingDefaultXml', 481],
    ['CancelResponseEncodingDefaultBinary', 482],
    ['AddNodesResult', 483],
    ['AddNodesResultEncodingDefaultXml', 484],
    ['AddNodesResultEncodingDefaultBinary', 485],
    ['AddNodesRequest', 486],
    ['AddNodesRequestEncodingDefaultXml', 487],
    ['AddNodesRequestEncodingDefaultBinary', 488],
    ['AddNodesResponse', 489],
    ['AddNodesResponseEncodingDefaultXml', 490],
    ['AddNodesResponseEncodingDefaultBinary', 491],
    ['AddReferencesRequest', 492],
    ['AddReferencesRequestEncodingDefaultXml', 493],
    ['AddReferencesRequestEncodingDefaultBinary', 494],
    ['AddReferencesResponse', 495],
    ['AddReferencesResponseEncodingDefaultXml', 496],
    ['AddReferencesResponseEncodingDefaultBinary', 497],
    ['DeleteNodesRequest', 498],
    ['DeleteNodesRequestEncodingDefaultXml', 499],
    ['DeleteNodesRequestEncodingDefaultBinary', 500],
    ['DeleteNodesResponse', 501],
    ['DeleteNodesResponseEncodingDefaultXml', 502],
    ['DeleteNodesResponseEncodingDefaultBinary', 503],
    ['DeleteReferencesRequest', 504],
    ['DeleteReferencesRequestEncodingDefaultXml', 505],
    ['DeleteReferencesRequestEncodingDefaultBinary', 506],
    ['DeleteReferencesResponse', 507],
    ['DeleteReferencesResponseEncodingDefaultXml', 508],
    ['DeleteReferencesResponseEncodingDefaultBinary', 509],
    ['BrowseDirection', 510],
    ['ViewDescription', 511],
    ['ViewDescriptionEncodingDefaultXml', 512],
    ['ViewDescriptionEncodingDefaultBinary', 513],
    ['BrowseDescription', 514],
    ['BrowseDescriptionEncodingDefaultXml', 515],
    ['BrowseDescriptionEncodingDefaultBinary', 516],
    ['BrowseResultMask', 517],
    ['ReferenceDescription', 518],
    ['ReferenceDescriptionEncodingDefaultXml', 519],
    ['ReferenceDescriptionEncodingDefaultBinary', 520],
    ['ContinuationPoint', 521],
    ['BrowseResult', 522],
    ['BrowseResultEncodingDefaultXml', 523],
    ['BrowseResultEncodingDefaultBinary', 524],
    ['BrowseRequest', 525],
    ['BrowseRequestEncodingDefaultXml', 526],
    ['BrowseRequestEncodingDefaultBinary', 527],
    ['BrowseResponse', 528],
    ['BrowseResponseEncodingDefaultXml', 529],
    ['BrowseResponseEncodingDefaultBinary', 530],
    ['BrowseNextRequest', 531],
    ['BrowseNextRequestEncodingDefaultXml', 532],
    ['BrowseNextRequestEncodingDefaultBinary', 533],
    ['BrowseNextResponse', 534],
    ['BrowseNextResponseEncodingDefaultXml', 535],
    ['BrowseNextResponseEncodingDefaultBinary', 536],
    ['RelativePathElement', 537],
    ['RelativePathElementEncodingDefaultXml', 538],
    ['RelativePathElementEncodingDefaultBinary', 539],
    ['RelativePath', 540],
    ['RelativePathEncodingDefaultXml', 541],
    ['RelativePathEncodingDefaultBinary', 542],
    ['BrowsePath', 543],
    ['BrowsePathEncodingDefaultXml', 544],
    ['BrowsePathEncodingDefaultBinary', 545],
    ['BrowsePathTarget', 546],
    ['BrowsePathTargetEncodingDefaultXml', 547],
    ['BrowsePathTargetEncodingDefaultBinary', 548],
    ['BrowsePathResult', 549],
    ['BrowsePathResultEncodingDefaultXml', 550],
    ['BrowsePathResultEncodingDefaultBinary', 551],
    ['TranslateBrowsePathsToNodeIdsRequest', 552],
    ['TranslateBrowsePathsToNodeIdsRequestEncodingDefaultXml', 553],
    ['TranslateBrowsePathsToNodeIdsRequestEncodingDefaultBinary', 554],
    ['TranslateBrowsePathsToNodeIdsResponse', 555],
    ['TranslateBrowsePathsToNodeIdsResponseEncodingDefaultXml', 556],
    ['TranslateBrowsePathsToNodeIdsResponseEncodingDefaultBinary', 557],
    ['RegisterNodesRequest', 558],
    ['RegisterNodesRequestEncodingDefaultXml', 559],
    ['RegisterNodesRequestEncodingDefaultBinary', 560],
    ['RegisterNodesResponse', 561],
    ['RegisterNodesResponseEncodingDefaultXml', 562],
    ['RegisterNodesResponseEncodingDefaultBinary', 563],
    ['UnregisterNodesRequest', 564],
    ['UnregisterNodesRequestEncodingDefaultXml', 565],
    ['UnregisterNodesRequestEncodingDefaultBinary', 566],
    ['UnregisterNodesResponse', 567],
    ['UnregisterNodesResponseEncodingDefaultXml', 568],
    ['UnregisterNodesResponseEncodingDefaultBinary', 569],
    ['QueryDataDescription', 570],
    ['QueryDataDescriptionEncodingDefaultXml', 571],
    ['QueryDataDescriptionEncodingDefaultBinary', 572],
    ['NodeTypeDescription', 573],
    ['NodeTypeDescriptionEncodingDefaultXml', 574],
    ['NodeTypeDescriptionEncodingDefaultBinary', 575],
    ['FilterOperator', 576],
    ['QueryDataSet', 577],
    ['QueryDataSetEncodingDefaultXml', 578],
    ['QueryDataSetEncodingDefaultBinary', 579],
    ['NodeReference', 580],
    ['NodeReferenceEncodingDefaultXml', 581],
    ['NodeReferenceEncodingDefaultBinary', 582],
    ['ContentFilterElement', 583],
    ['ContentFilterElementEncodingDefaultXml', 584],
    ['ContentFilterElementEncodingDefaultBinary', 585],
    ['ContentFilter', 586],
    ['ContentFilterEncodingDefaultXml', 587],
    ['ContentFilterEncodingDefaultBinary', 588],
    ['FilterOperand', 589],
    ['FilterOperandEncodingDefaultXml', 590],
    ['FilterOperandEncodingDefaultBinary', 591],
    ['ElementOperand', 592],
    ['ElementOperandEncodingDefaultXml', 593],
    ['ElementOperandEncodingDefaultBinary', 594],
    ['LiteralOperand', 595],
    ['LiteralOperandEncodingDefaultXml', 596],
    ['LiteralOperandEncodingDefaultBinary', 597],
    ['AttributeOperand', 598],
    ['AttributeOperandEncodingDefaultXml', 599],
    ['AttributeOperandEncodingDefaultBinary', 600],
    ['SimpleAttributeOperand', 601],
    ['SimpleAttributeOperandEncodingDefaultXml', 602],
    ['SimpleAttributeOperandEncodingDefaultBinary', 603],
    ['ContentFilterElementResult', 604],
    ['ContentFilterElementResultEncodingDefaultXml', 605],
    ['ContentFilterElementResultEncodingDefaultBinary', 606],
    ['ContentFilterResult', 607],
    ['ContentFilterResultEncodingDefaultXml', 608],
    ['ContentFilterResultEncodingDefaultBinary', 609],
    ['ParsingResult', 610],
    ['ParsingResultEncodingDefaultXml', 611],
    ['ParsingResultEncodingDefaultBinary', 612],
    ['QueryFirstRequest', 613],
    ['QueryFirstRequestEncodingDefaultXml', 614],
    ['QueryFirstRequestEncodingDefaultBinary', 615],
    ['QueryFirstResponse', 616],
    ['QueryFirstResponseEncodingDefaultXml', 617],
    ['QueryFirstResponseEncodingDefaultBinary', 618],
    ['QueryNextRequest', 619],
    ['QueryNextRequestEncodingDefaultXml', 620],
    ['QueryNextRequestEncodingDefaultBinary', 621],
    ['QueryNextResponse', 622],
    ['QueryNextResponseEncodingDefaultXml', 623],
    ['QueryNextResponseEncodingDefaultBinary', 624],
    ['TimestampsToReturn', 625],
    ['ReadValueId', 626],
    ['ReadValueIdEncodingDefaultXml', 627],
    ['ReadValueIdEncodingDefaultBinary', 628],
    ['ReadRequest', 629],
    ['ReadRequestEncodingDefaultXml', 630],
    ['ReadRequestEncodingDefaultBinary', 631],
    ['ReadResponse', 632],
    ['ReadResponseEncodingDefaultXml', 633],
    ['ReadResponseEncodingDefaultBinary', 634],
    ['HistoryReadValueId', 635],
    ['HistoryReadValueIdEncodingDefaultXml', 636],
    ['HistoryReadValueIdEncodingDefaultBinary', 637],
    ['HistoryReadResult', 638],
    ['HistoryReadResultEncodingDefaultXml', 639],
    ['HistoryReadResultEncodingDefaultBinary', 640],
    ['HistoryReadDetails', 641],
    ['HistoryReadDetailsEncodingDefaultXml', 642],
    ['HistoryReadDetailsEncodingDefaultBinary', 643],
    ['ReadEventDetails', 644],
    ['ReadEventDetailsEncodingDefaultXml', 645],
    ['ReadEventDetailsEncodingDefaultBinary', 646],
    ['ReadRawModifiedDetails', 647],
    ['ReadRawModifiedDetailsEncodingDefaultXml', 648],
    ['ReadRawModifiedDetailsEncodingDefaultBinary', 649],
    ['ReadProcessedDetails', 650],
    ['ReadProcessedDetailsEncodingDefaultXml', 651],
    ['ReadProcessedDetailsEncodingDefaultBinary', 652],
    ['ReadAtTimeDetails', 653],
    ['ReadAtTimeDetailsEncodingDefaultXml', 654],
    ['ReadAtTimeDetailsEncodingDefaultBinary', 655],
    ['HistoryData', 656],
    ['HistoryDataEncodingDefaultXml', 657],
    ['HistoryDataEncodingDefaultBinary', 658],
    ['HistoryEvent', 659],
    ['HistoryEventEncodingDefaultXml', 660],
    ['HistoryEventEncodingDefaultBinary', 661],
    ['HistoryReadRequest', 662],
    ['HistoryReadRequestEncodingDefaultXml', 663],
    ['HistoryReadRequestEncodingDefaultBinary', 664],
    ['HistoryReadResponse', 665],
    ['HistoryReadResponseEncodingDefaultXml', 666],
    ['HistoryReadResponseEncodingDefaultBinary', 667],
    ['WriteValue', 668],
    ['WriteValueEncodingDefaultXml', 669],
    ['WriteValueEncodingDefaultBinary', 670],
    ['WriteRequest', 671],
    ['WriteRequestEncodingDefaultXml', 672],
    ['WriteRequestEncodingDefaultBinary', 673],
    ['WriteResponse', 674],
    ['WriteResponseEncodingDefaultXml', 675],
    ['WriteResponseEncodingDefaultBinary', 676],
    ['HistoryUpdateDetails', 677],
    ['HistoryUpdateDetailsEncodingDefaultXml', 678],
    ['HistoryUpdateDetailsEncodingDefaultBinary', 679],
    ['UpdateDataDetails', 680],
    ['UpdateDataDetailsEncodingDefaultXml', 681],
    ['UpdateDataDetailsEncodingDefaultBinary', 682],
    ['UpdateEventDetails', 683],
    ['UpdateEventDetailsEncodingDefaultXml', 684],
    ['UpdateEventDetailsEncodingDefaultBinary', 685],
    ['DeleteRawModifiedDetails', 686],
    ['DeleteRawModifiedDetailsEncodingDefaultXml', 687],
    ['DeleteRawModifiedDetailsEncodingDefaultBinary', 688],
    ['DeleteAtTimeDetails', 689],
    ['DeleteAtTimeDetailsEncodingDefaultXml', 690],
    ['DeleteAtTimeDetailsEncodingDefaultBinary', 691],
    ['DeleteEventDetails', 692],
    ['DeleteEventDetailsEncodingDefaultXml', 693],
    ['DeleteEventDetailsEncodingDefaultBinary', 694],
    ['HistoryUpdateResult', 695],
    ['HistoryUpdateResultEncodingDefaultXml', 696],
    ['HistoryUpdateResultEncodingDefaultBinary', 697],
    ['HistoryUpdateRequest', 698],
    ['HistoryUpdateRequestEncodingDefaultXml', 699],
    ['HistoryUpdateRequestEncodingDefaultBinary', 700],
    ['HistoryUpdateResponse', 701],
    ['HistoryUpdateResponseEncodingDefaultXml', 702],
    ['HistoryUpdateResponseEncodingDefaultBinary', 703],
    ['CallMethodRequest', 704],
    ['CallMethodRequestEncodingDefaultXml', 705],
    ['CallMethodRequestEncodingDefaultBinary', 706],
    ['CallMethodResult', 707],
    ['CallMethodResultEncodingDefaultXml', 708],
    ['CallMethodResultEncodingDefaultBinary', 709],
    ['CallRequest', 710],
    ['CallRequestEncodingDefaultXml', 711],
    ['CallRequestEncodingDefaultBinary', 712],
    ['CallResponse', 713],
    ['CallResponseEncodingDefaultXml', 714],
    ['CallResponseEncodingDefaultBinary', 715],
    ['MonitoringMode', 716],
    ['DataChangeTrigger', 717],
    ['DeadbandType', 718],
    ['MonitoringFilter', 719],
    ['MonitoringFilterEncodingDefaultXml', 720],
    ['MonitoringFilterEncodingDefaultBinary', 721],
    ['DataChangeFilter', 722],
    ['DataChangeFilterEncodingDefaultXml', 723],
    ['DataChangeFilterEncodingDefaultBinary', 724],
    ['EventFilter', 725],
    ['EventFilterEncodingDefaultXml', 726],
    ['EventFilterEncodingDefaultBinary', 727],
    ['AggregateFilter', 728],
    ['AggregateFilterEncodingDefaultXml', 729],
    ['AggregateFilterEncodingDefaultBinary', 730],
    ['MonitoringFilterResult', 731],
    ['MonitoringFilterResultEncodingDefaultXml', 732],
    ['MonitoringFilterResultEncodingDefaultBinary', 733],
    ['EventFilterResult', 734],
    ['EventFilterResultEncodingDefaultXml', 735],
    ['EventFilterResultEncodingDefaultBinary', 736],
    ['AggregateFilterResult', 737],
    ['AggregateFilterResultEncodingDefaultXml', 738],
    ['AggregateFilterResultEncodingDefaultBinary', 739],
    ['MonitoringParameters', 740],
    ['MonitoringParametersEncodingDefaultXml', 741],
    ['MonitoringParametersEncodingDefaultBinary', 742],
    ['MonitoredItemCreateRequest', 743],
    ['MonitoredItemCreateRequestEncodingDefaultXml', 744],
    ['MonitoredItemCreateRequestEncodingDefaultBinary', 745],
    ['MonitoredItemCreateResult', 746],
    ['MonitoredItemCreateResultEncodingDefaultXml', 747],
    ['MonitoredItemCreateResultEncodingDefaultBinary', 748],
    ['CreateMonitoredItemsRequest', 749],
    ['CreateMonitoredItemsRequestEncodingDefaultXml', 750],
    ['CreateMonitoredItemsRequestEncodingDefaultBinary', 751],
    ['CreateMonitoredItemsResponse', 752],
    ['CreateMonitoredItemsResponseEncodingDefaultXml', 753],
    ['CreateMonitoredItemsResponseEncodingDefaultBinary', 754],
    ['MonitoredItemModifyRequest', 755],
    ['MonitoredItemModifyRequestEncodingDefaultXml', 756],
    ['MonitoredItemModifyRequestEncodingDefaultBinary', 757],
    ['MonitoredItemModifyResult', 758],
    ['MonitoredItemModifyResultEncodingDefaultXml', 759],
    ['MonitoredItemModifyResultEncodingDefaultBinary', 760],
    ['ModifyMonitoredItemsRequest', 761],
    ['ModifyMonitoredItemsRequestEncodingDefaultXml', 762],
    ['ModifyMonitoredItemsRequestEncodingDefaultBinary', 763],
    ['ModifyMonitoredItemsResponse', 764],
    ['ModifyMonitoredItemsResponseEncodingDefaultXml', 765],
    ['ModifyMonitoredItemsResponseEncodingDefaultBinary', 766],
    ['SetMonitoringModeRequest', 767],
    ['SetMonitoringModeRequestEncodingDefaultXml', 768],
    ['SetMonitoringModeRequestEncodingDefaultBinary', 769],
    ['SetMonitoringModeResponse', 770],
    ['SetMonitoringModeResponseEncodingDefaultXml', 771],
    ['SetMonitoringModeResponseEncodingDefaultBinary', 772],
    ['SetTriggeringRequest', 773],
    ['SetTriggeringRequestEncodingDefaultXml', 774],
    ['SetTriggeringRequestEncodingDefaultBinary', 775],
    ['SetTriggeringResponse', 776],
    ['SetTriggeringResponseEncodingDefaultXml', 777],
    ['SetTriggeringResponseEncodingDefaultBinary', 778],
    ['DeleteMonitoredItemsRequest', 779],
    ['DeleteMonitoredItemsRequestEncodingDefaultXml', 780],
    ['DeleteMonitoredItemsRequestEncodingDefaultBinary', 781],
    ['DeleteMonitoredItemsResponse', 782],
    ['DeleteMonitoredItemsResponseEncodingDefaultXml', 783],
    ['DeleteMonitoredItemsResponseEncodingDefaultBinary', 784],
    ['CreateSubscriptionRequest', 785],
    ['CreateSubscriptionRequestEncodingDefaultXml', 786],
    ['CreateSubscriptionRequestEncodingDefaultBinary', 787],
    ['CreateSubscriptionResponse', 788],
    ['CreateSubscriptionResponseEncodingDefaultXml', 789],
    ['CreateSubscriptionResponseEncodingDefaultBinary', 790],
    ['ModifySubscriptionRequest', 791],
    ['ModifySubscriptionRequestEncodingDefaultXml', 792],
    ['ModifySubscriptionRequestEncodingDefaultBinary', 793],
    ['ModifySubscriptionResponse', 794],
    ['ModifySubscriptionResponseEncodingDefaultXml', 795],
    ['ModifySubscriptionResponseEncodingDefaultBinary', 796],
    ['SetPublishingModeRequest', 797],
    ['SetPublishingModeRequestEncodingDefaultXml', 798],
    ['SetPublishingModeRequestEncodingDefaultBinary', 799],
    ['SetPublishingModeResponse', 800],
    ['SetPublishingModeResponseEncodingDefaultXml', 801],
    ['SetPublishingModeResponseEncodingDefaultBinary', 802],
    ['NotificationMessage', 803],
    ['NotificationMessageEncodingDefaultXml', 804],
    ['NotificationMessageEncodingDefaultBinary', 805],
    ['MonitoredItemNotification', 806],
    ['MonitoredItemNotificationEncodingDefaultXml', 807],
    ['MonitoredItemNotificationEncodingDefaultBinary', 808],
    ['DataChangeNotification', 809],
    ['DataChangeNotificationEncodingDefaultXml', 810],
    ['DataChangeNotificationEncodingDefaultBinary', 811],
    ['StatusChangeNotification', 818],
    ['StatusChangeNotificationEncodingDefaultXml', 819],
    ['StatusChangeNotificationEncodingDefaultBinary', 820],
    ['SubscriptionAcknowledgement', 821],
    ['SubscriptionAcknowledgementEncodingDefaultXml', 822],
    ['SubscriptionAcknowledgementEncodingDefaultBinary', 823],
    ['PublishRequest', 824],
    ['PublishRequestEncodingDefaultXml', 825],
    ['PublishRequestEncodingDefaultBinary', 826],
    ['PublishResponse', 827],
    ['PublishResponseEncodingDefaultXml', 828],
    ['PublishResponseEncodingDefaultBinary', 829],
    ['RepublishRequest', 830],
    ['RepublishRequestEncodingDefaultXml', 831],
    ['RepublishRequestEncodingDefaultBinary', 832],
    ['RepublishResponse', 833],
    ['RepublishResponseEncodingDefaultXml', 834],
    ['RepublishResponseEncodingDefaultBinary', 835],
    ['TransferResult', 836],
    ['TransferResultEncodingDefaultXml', 837],
    ['TransferResultEncodingDefaultBinary', 838],
    ['TransferSubscriptionsRequest', 839],
    ['TransferSubscriptionsRequestEncodingDefaultXml', 840],
    ['TransferSubscriptionsRequestEncodingDefaultBinary', 841],
    ['TransferSubscriptionsResponse', 842],
    ['TransferSubscriptionsResponseEncodingDefaultXml', 843],
    ['TransferSubscriptionsResponseEncodingDefaultBinary', 844],
    ['DeleteSubscriptionsRequest', 845],
    ['DeleteSubscriptionsRequestEncodingDefaultXml', 846],
    ['DeleteSubscriptionsRequestEncodingDefaultBinary', 847],
    ['DeleteSubscriptionsResponse', 848],
    ['DeleteSubscriptionsResponseEncodingDefaultXml', 849],
    ['DeleteSubscriptionsResponseEncodingDefaultBinary', 850],
    ['RedundancySupport', 851],
    ['ServerState', 852],
    ['RedundantServerDataType', 853],
    ['RedundantServerDataTypeEncodingDefaultXml', 854],
    ['RedundantServerDataTypeEncodingDefaultBinary', 855],
    ['SamplingIntervalDiagnosticsDataType', 856],
    ['SamplingIntervalDiagnosticsDataTypeEncodingDefaultXml', 857],
    ['SamplingIntervalDiagnosticsDataTypeEncodingDefaultBinary', 858],
    ['ServerDiagnosticsSummaryDataType', 859],
    ['ServerDiagnosticsSummaryDataTypeEncodingDefaultXml', 860],
    ['ServerDiagnosticsSummaryDataTypeEncodingDefaultBinary', 861],
    ['ServerStatusDataType', 862],
    ['ServerStatusDataTypeEncodingDefaultXml', 863],
    ['ServerStatusDataTypeEncodingDefaultBinary', 864],
    ['SessionDiagnosticsDataType', 865],
    ['SessionDiagnosticsDataTypeEncodingDefaultXml', 866],
    ['SessionDiagnosticsDataTypeEncodingDefaultBinary', 867],
    ['SessionSecurityDiagnosticsDataType', 868],
    ['SessionSecurityDiagnosticsDataTypeEncodingDefaultXml', 869],
    ['SessionSecurityDiagnosticsDataTypeEncodingDefaultBinary', 870],
    ['ServiceCounterDataType', 871],
    ['ServiceCounterDataTypeEncodingDefaultXml', 872],
    ['ServiceCounterDataTypeEncodingDefaultBinary', 873],
    ['SubscriptionDiagnosticsDataType', 874],
    ['SubscriptionDiagnosticsDataTypeEncodingDefaultXml', 875],
    ['SubscriptionDiagnosticsDataTypeEncodingDefaultBinary', 876],
    ['ModelChangeStructureDataType', 877],
    ['ModelChangeStructureDataTypeEncodingDefaultXml', 878],
    ['ModelChangeStructureDataTypeEncodingDefaultBinary', 879],
    ['Range', 884],
    ['RangeEncodingDefaultXml', 885],
    ['RangeEncodingDefaultBinary', 886],
    ['EUInformation', 887],
    ['EUInformationEncodingDefaultXml', 888],
    ['EUInformationEncodingDefaultBinary', 889],
    ['ExceptionDeviationFormat', 890],
    ['Annotation', 891],
    ['AnnotationEncodingDefaultXml', 892],
    ['AnnotationEncodingDefaultBinary', 893],
    ['ProgramDiagnosticDataType', 894],
    ['ProgramDiagnosticDataTypeEncodingDefaultXml', 895],
    ['ProgramDiagnosticDataTypeEncodingDefaultBinary', 896],
    ['SemanticChangeStructureDataType', 897],
    ['SemanticChangeStructureDataTypeEncodingDefaultXml', 898],
    ['SemanticChangeStructureDataTypeEncodingDefaultBinary', 899],
    ['EventNotificationList', 914],
    ['EventNotificationListEncodingDefaultXml', 915],
    ['EventNotificationListEncodingDefaultBinary', 916],
    ['EventFieldList', 917],
    ['EventFieldListEncodingDefaultXml', 918],
    ['EventFieldListEncodingDefaultBinary', 919],
    ['HistoryEventFieldList', 920],
    ['HistoryEventFieldListEncodingDefaultXml', 921],
    ['HistoryEventFieldListEncodingDefaultBinary', 922],
    ['IssuedIdentityToken', 938],
    ['IssuedIdentityTokenEncodingDefaultXml', 939],
    ['IssuedIdentityTokenEncodingDefaultBinary', 940],
    ['NotificationData', 945],
    ['NotificationDataEncodingDefaultXml', 946],
    ['NotificationDataEncodingDefaultBinary', 947],
    ['AggregateConfiguration', 948],
    ['AggregateConfigurationEncodingDefaultXml', 949],
    ['AggregateConfigurationEncodingDefaultBinary', 950]
]);
